"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5275],{

/***/ 82316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12451);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);




const linkVariants = {
    hover: {
        scale: 1.05
    }
};
const TextLink = (param)=>{
    let { children , className , style , ignoreTheme =false  } = param;
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    const isUrl = (word)=>{
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
        return urlPattern.test(word);
    };
    const processText = (text)=>{
        return text.split(/\n/).map((line, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    whiteSpace: "pre-wrap",
                    margin: 0
                },
                children: line.split(" ").map((word, index)=>{
                    if (isUrl(word)) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.a */ .E.a, {
                            href: word,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: ignoreTheme ? {} : {
                                color: theme === null || theme === void 0 ? void 0 : theme.textColour
                            },
                            className: "text-blue-500 underline break-words",
                            variants: linkVariants,
                            whileHover: "hover",
                            children: word
                        }, index);
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "break-words",
                        children: [
                            word,
                            " "
                        ]
                    }, index);
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        style: {
            ...!ignoreTheme && {
                color: theme === null || theme === void 0 ? void 0 : theme.textColour
            },
            ...style
        },
        children: typeof children === "string" ? processText(children) : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextLink);


/***/ }),

/***/ 39889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export EventDateTime */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_EventTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26647);


const EventDateTime = (param)=>{
    let { value , format , event , className , secondaryClassName ="ml-1 text-xs opacity-75" , showViewerLocal =true , viewerTimeZoneId  } = param;
    if (!value) return null;
    const display = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_1__/* .getEventDateTimeDisplay */ .$Y)(value, format, event, viewerTimeZoneId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
            dateTime: display.dateTime,
            children: display.eventLocal
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventDateTime);


/***/ }),

/***/ 55256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ SessionList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_ProfileImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19527);
/* harmony import */ var _libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24499);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_event_EventDateTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39889);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37106);
/* harmony import */ var _base_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51773);
/* harmony import */ var _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96963);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57632);











const SessionList = (param)=>{
    let { sessions , eventId , eventType , timeZone , timeZoneId  } = param;
    var ref;
    const { profile  } = (0,_libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    const isAdmin = profile === null || profile === void 0 ? void 0 : (ref = profile.groups) === null || ref === void 0 ? void 0 : ref.includes("forumm-admin");
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
        className: "my-4 w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                className: "min-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    className: "grid grid-cols-[1fr_2fr_1fr] sm:grid-cols-[1fr_2fr_1fr_1fr] md:grid-cols-[1fr_2fr_2fr_1fr_1fr] font-medium text-md gap-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden",
                            children: "When"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden",
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-auto hidden md:inline-block",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden",
                            children: "Stage"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden hidden sm:inline-block",
                            children: "Speakers"
                        })
                    ]
                })
            }),
            sessions && sessions.map((s, i)=>{
                var ref;
                const hasEventStarted = moment__WEBPACK_IMPORTED_MODULE_4___default()().isBefore(s.endDateTime) && moment__WEBPACK_IMPORTED_MODULE_4___default()().add(5, "minutes").isAfter(s.startDateTime);
                const handleClick = ()=>{
                    var ref;
                    if (((ref = s.stage) === null || ref === void 0 ? void 0 : ref.title) && !s.isBreak && hasEventStarted) push("/event/".concat(eventId, "/stages/").concat(encodeURIComponent(s.stage.title)));
                };
                var ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    className: "grid grid-cols-[1fr_2fr_1fr] sm:grid-cols-[1fr_2fr_1fr_1fr] md:grid-cols-[1fr_2fr_2fr_1fr_1fr] pt-4 mb-4 gap-1 p-1 border-t ".concat(hasEventStarted ? "cursor-pointer" : ""),
                    "data-testid": "sessionList__item_".concat(i),
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden ".concat(s.isBreak ? "border-l-orange-200" : "border-l-blue-500"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_EventDateTime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    value: s.startDateTime,
                                    format: "MMM DD, h:mmA",
                                    event: {
                                        timeZoneId,
                                        timeZone
                                    }
                                }),
                                " - ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_EventDateTime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    value: s.endDateTime,
                                    format: "MMM DD, h:mmA",
                                    event: {
                                        timeZoneId,
                                        timeZone
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-hidden",
                            children: s.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left overflow-auto hidden md:inline-block",
                            children: s.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left items-center justify-center overflow-hidden",
                            children: !s.isBreak && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_9__/* .TbPodium */ .eT5, {
                                        className: "w-5 h-5 mr-2 inline"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (ref = s.stage) === null || ref === void 0 ? void 0 : ref.title
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            className: "text-left hidden sm:inline-block",
                            children: s.speakers && s.speakers.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                className: "flex",
                                children: s.speakers.map((speaker, index)=>{
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_ProfileImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        className: "".concat(index > 0 ? "-ml-5" : ""),
                                        imageUrl: (speaker === null || speaker === void 0 ? void 0 : speaker.profileImage) || _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"].src */ .Z.src,
                                        tooltip: [
                                            speaker === null || speaker === void 0 ? void 0 : speaker.name,
                                            speaker === null || speaker === void 0 ? void 0 : speaker.position,
                                            speaker === null || speaker === void 0 ? void 0 : speaker.organization
                                        ]
                                    }, (ref1 = speaker === null || speaker === void 0 ? void 0 : speaker.email) !== null && ref1 !== void 0 ? ref1 : (0,uuid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)());
                                })
                            }) : "-"
                        })
                    ]
                }, i);
            })
        ]
    });
};


/***/ }),

/***/ 98805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CheckboxInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73912);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for checkbox inputs.
 */ const CheckboxInput = (param)=>{
    let { label , show =true , value ="" , onChange , className , validations , required , testid , children , border ="border" , customStyles  } = param;
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, validations);
    const checked = value === true;
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: "flex flex-col gap-3 bg-transparent text-sm transition-all ".concat(errorMessage ? "text-red-500" : "", " ").concat(className),
        children: [
            label && (border === null || border === void 0 ? void 0 : border.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                className: "text-sm font-medium text-[#153e3e] transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    show: required,
                    tooltip: "Required to publish.",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: required ? "after:content-['*'] after:ml-1 after:text-red-500" : "",
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex w-full cursor-pointer items-start gap-2 text-sm font-medium text-[#153e3e] ".concat(customStyles !== null && customStyles !== void 0 ? customStyles : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        "data-testid": testid ? "".concat(testid) : null,
                        type: "checkbox",
                        className: "peer sr-only",
                        name: label,
                        checked: checked,
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        onChange: (e)=>{
                            onChange && onChange(e.target.checked, false);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        className: "mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center border-2 border-[#153e3e] bg-transparent transition-all after:hidden after:h-2 after:w-1 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white peer-checked:bg-[#153e3e] peer-checked:after:block peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "min-w-0 text-[#153e3e]",
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 55369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ InputPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68240);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _CheckboxInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98805);
/* harmony import */ var _DateTimeInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8194);
/* harmony import */ var _DropdownInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61993);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39618);
/* harmony import */ var _ToggleInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20970);









const InputPicker = (props)=>{
    const { ukey , type , label , placeholder , value ="" , onChange , className , validations , required , show =true , testid , error , outputFormat ="unset"  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (error) console.log("InputPicker<".concat(type, "> Error: ").concat(error));
    }, [
        error
    ]);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    const onChangeFormatted = (e)=>{
        let payload = e;
        if (outputFormat === "string") payload = "".concat(e);
        onChange && onChange(payload);
    };
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .FormInputType.Number */ .Tx.Number) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
            show: show,
            required: required,
            validations: validations,
            value: value,
            onChange: onChangeFormatted,
            label: label,
            placeholder: placeholder,
            className: className,
            testid: testid,
            error: error,
            type: "number"
        }, ukey);
    // return (
    //   <CountInput
    //     show={show}
    //     key={ukey}
    //     required={required}
    //     validations={validations}
    //     value={!!value ? (isNaN(parseInt(value)) ? 0 : parseInt(value)) : 0}
    //     onChange={(e) => {
    //       onChangeFormatted(`${e}`)
    //     }}
    //     label={label}
    //     placeholder={placeholder}
    //     minValue={props.min}
    //     maxValue={props.max}
    //     className={className}
    //     testid={testid}
    //     error={error}
    //   />
    // )
    }
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .FormInputType.Dropdown */ .Tx.Dropdown) {
        var _options;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DropdownInput__WEBPACK_IMPORTED_MODULE_6__/* .DropdownInput */ .f, {
            show: show,
            required: required,
            validations: validations,
            value: value,
            onChange: onChangeFormatted,
            label: label,
            placeholder: placeholder,
            options: (_options = props.options) !== null && _options !== void 0 ? _options : [],
            className: className,
            testid: testid,
            error: error
        }, ukey);
    }
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .FormInputType.Date */ .Tx.Date) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DateTimeInput__WEBPACK_IMPORTED_MODULE_5__/* .DateTimeInput */ .Y, {
            show: show,
            required: required,
            className: className,
            initialDate: props.initialDate,
            label: label,
            filterDate: props.filterDate,
            filterTime: props.filterTime,
            dateOnly: props.dateOnly,
            value: moment__WEBPACK_IMPORTED_MODULE_2___default()(value).toISOString(),
            onChange: onChangeFormatted,
            testid: testid,
            error: error
        }, ukey);
    }
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .FormInputType.Bool */ .Tx.Bool) {
        const BoolOptions = [
            "Yes",
            "No"
        ];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ToggleInput__WEBPACK_IMPORTED_MODULE_8__/* .ToggleInput */ .s, {
            show: show,
            required: required,
            selected: BoolOptions.findIndex((o)=>o.toLowerCase() === value.toLowerCase()),
            centerText: true,
            options: BoolOptions,
            className: "w-full mt-4 ".concat(className),
            value: value,
            callback: onChangeFormatted,
            label: label,
            testid: testid,
            error: error
        }, ukey);
    }
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .FormInputType.Checkbox */ .Tx.Checkbox) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CheckboxInput__WEBPACK_IMPORTED_MODULE_4__/* .CheckboxInput */ .I, {
            isProtected: true,
            show: show,
            required: required,
            className: "w-full mt-4 justify-start ".concat(className),
            customStyles: "!justify-start",
            value: value !== undefined && typeof value === "boolean" ? value : value.toLowerCase() === "true",
            onChange: onChangeFormatted,
            // label={label}
            border: "",
            testid: testid,
            error: error,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: label
            })
        }, ukey);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
        show: show,
        required: required,
        validations: validations,
        value: value,
        onChange: onChangeFormatted,
        label: label,
        placeholder: placeholder,
        className: className,
        testid: testid,
        error: error
    }, ukey);
};


/***/ }),

/***/ 34975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GET_EVENT_BY_ID_FOR_UNREGISTERED_USER; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_EVENT_BY_ID_FOR_UNREGISTERED_USER = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query getEventByIdForUnregisteredUser(\n    $input: GetEventByIdForUnregisteredUserInput!\n  ) {\n    getEventByIdForUnregisteredUser(input: $input) {\n      ...EventPublic\n    }\n  }\n");


/***/ }),

/***/ 31049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ GET_ORDER_BY_ID; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetOrderById($orderId: String!) {\n    getOrderById(orderId: $orderId) {\n      userId\n      eventId\n      quantity\n      paid\n      paymentProcessor\n      paymentStatus\n      paymentLastUpdated\n      tickets {\n        title\n        email\n        fullName\n        discountCode\n        ticketCode\n        isAdditionalGuest\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const GET_ORDER_BY_ID = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 31157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ GET_ORDERS_BY_EVENT_ID; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getOrdersByEventId($eventId: String!, $userIds: [String!]!) {\n    getOrdersByEventId(eventId: $eventId, userIds: $userIds) {\n      orderId\n      userId\n      paid\n      paymentProcessor\n      paymentStatus\n      paymentLastUpdated\n      eventId\n      quantity\n      tickets {\n        title\n        email\n        fullName\n        discountCode\n        ticketCode\n        isAdditionalGuest\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const GET_ORDERS_BY_EVENT_ID = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 25875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ GoogleAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const ADS_ENABLED = "false";
const DEBUG_MODE = false;
const GoogleAds = (param)=>{
    let { type , show =true , className =""  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        try {
            if (!show) return;
            if (true) {
                if (!window.adsbygoogle) window.adsbygoogle = [];
                window.adsbygoogle.push({});
                console.log({
                    ads: window.adsbygoogle
                });
            } else {}
        } catch (err) {
            if (DEBUG_MODE) console.log(err);
            else console.log("Ad Error Suppressed.");
        }
    }, []);
    if ((ADS_ENABLED === null || ADS_ENABLED === void 0 ? void 0 : ADS_ENABLED.toLowerCase()) !== "true" || !show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (type === "square") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                // display: 'inline-block',
                display: "block",
                // height: '90px',
                // width: '100%',
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "9657998552",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "vertical") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "100%",
                width: "300px",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "3092590200",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "horizontal") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "90px",
                width: "100%",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "2515404500",
            "data-ad-format": "inline",
            "data-full-width-responsive": "false"
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};


/***/ }),

/***/ 79258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ usePaymentStatusPolling; }
/* harmony export */ });
/* harmony import */ var _graphql_events_GetOrderById__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const usePaymentStatusPolling = function(orderId) {
    let enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [order, setOrder] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("idle");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!enabled || !orderId) {
            setState("idle");
            return;
        }
        let stopped = false;
        let timer;
        const deadline = Date.now() + 5 * 60 * 1000;
        setState("processing");
        const poll = async ()=>{
            try {
                var ref;
                const { apolloClient  } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10796));
                const response = await apolloClient.query({
                    query: _graphql_events_GetOrderById__WEBPACK_IMPORTED_MODULE_0__/* .GET_ORDER_BY_ID */ .b,
                    variables: {
                        orderId
                    },
                    fetchPolicy: "network-only"
                });
                if (stopped) return;
                const nextOrder = (ref = response.data) === null || ref === void 0 ? void 0 : ref.getOrderById;
                setOrder(nextOrder);
                const status = nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.paymentStatus;
                if ((nextOrder === null || nextOrder === void 0 ? void 0 : nextOrder.paid) || status === "SUCCEEDED") {
                    setState("confirmed");
                    return;
                }
                if ([
                    "FAILED",
                    "REFUNDED",
                    "CHARGED_BACK"
                ].includes(status !== null && status !== void 0 ? status : "")) {
                    setState("failed");
                    return;
                }
            } catch (_) {
            // Retry transient query failures until the five-minute deadline.
            }
            if (Date.now() >= deadline) {
                setState("timed_out");
                return;
            }
            timer = setTimeout(poll, 3000);
        };
        poll();
        return ()=>{
            stopped = true;
            if (timer) clearTimeout(timer);
        };
    }, [
        enabled,
        orderId
    ]);
    return {
        order,
        state
    };
};


/***/ }),

/***/ 35275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ EventPage; },
  "eventIdsMap": function() { return /* binding */ eventIdsMap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/GetEventPortalById.ts

const GET_EVENT_PORTAL_BY_ID = (0,_generated/* graphql */.B)("\n  query getEventPortalById($input: GetEventByIdInput!) {\n    getEventById(input: $input) {\n      ...EventPortal\n    }\n  }\n");

// EXTERNAL MODULE: ./graphql/events/GetEventByIdForUnregisteredUser.ts
var GetEventByIdForUnregisteredUser = __webpack_require__(34975);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/images/AnnouncementIcon.svg
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAnnouncementIcon = function SvgAnnouncementIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 1600,
    height: 1600,
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M392 800.73 235.27 529.09l-120.36 69.453c-75.09 43.273-100.73 139.27-57.453 214.18 43.273 75.09 139.27 100.73 214.18 57.453zM917.64 324.55c3.453 5.816 9.453 9.09 15.816 9.09 3.09 0 6.184-.727 9.09-2.363l144.55-83.453c8.726-5.09 11.637-16.184 6.726-24.91-4.91-8.727-16.184-11.637-24.91-6.727l-144.55 83.453c-8.722 5.09-11.633 16.18-6.722 24.91zM1144.7 445.09l-166.73 7.273c-10 .364-17.816 8.91-17.453 18.91.363 9.817 8.547 17.453 18.184 17.453h.727l166.73-7.273c10-.363 17.816-8.91 17.453-18.91-.364-9.996-9.09-17.453-18.91-17.453zM812 214c3.09 2 6.363 2.91 9.816 2.91 6 0 11.816-2.91 15.273-8.363l89.816-140.73c5.454-8.547 2.91-19.637-5.636-25.09-8.364-5.453-19.637-2.91-25.09 5.637l-89.637 140.73c-5.633 8.18-3.09 19.453 5.457 24.906zM385.82 846.36l-96 55.453c-12.91 7.453-26.547 13.09-40.727 17.273 17.273 85.273 61.09 163.09 125.09 221.82 23.816 22 59.453 25.637 87.453 9.273.727-.363 1.273-.726 2-1.09 40.91-23.636 50.184-79.09 18.547-114-47.816-53.272-81.09-118.36-96.363-188.73zM624.36 485.45c-42.363-73.453-154.73-278.73-156.91-392.73-37.09 48.184-55.637 128-80.91 196.55-29.453 92.184-69.816 165.27-123.27 216l163.45 283.27c70.547-20.91 154.18-19.273 248.55 1.273 71.816 12.363 150.18 36 210.36 28.184-104.91-65.64-243.45-301.82-261.27-332.55z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M514.91 54c-32.184 18.547 1.09 139.09 75.273 290.36 62.91-22 134.36 3.09 168.36 62.363 34.184 59.09 20.363 133.64-30.363 177.09 94.363 140.91 182.91 230.91 215.09 212.18 40.547-23.453-22.547-208.55-140.91-413.45-118.36-204.91-246.91-352-287.45-328.55z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M708.73 552.73c34.363-32.727 42.91-85.637 18.547-127.82-24.363-42.363-74.547-61.273-120-47.816 15.273 29.637 31.453 59.453 48.547 89.09a1989.363 1989.363 0 0 0 52.906 86.543z"
  })));
};
/* harmony default export */ var AnnouncementIcon = (SvgAnnouncementIcon);
// EXTERNAL MODULE: ./public/images/default-thumbnail.png
var default_thumbnail = __webpack_require__(96963);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./components/event/SessionList.tsx
var SessionList = __webpack_require__(55256);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(30047);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
;// CONCATENATED MODULE: ./graphql/events/sendAttendeeEmailsForEvent.ts

const SEND_ATTENDEE_EMAILS_FOR_EVENT = (0,_generated/* graphql */.B)("\n	mutation sendAttendeeEmailsForEvent(\n	  $emails: [String!]!\n	  $eventId: String!\n	) {\n	  sendAttendeeEmailsForEvent(\n	  emails: $emails\n	  eventId: $eventId\n	  )\n	}\n");

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 183 modules
var motion = __webpack_require__(12451);
// EXTERNAL MODULE: ./libs/currencies.ts
var libs_currencies = __webpack_require__(30530);
;// CONCATENATED MODULE: ./libs/Utility/csv.ts



const importAttendeesFromCSV = (CSVFile, readString)=>{
    if (!CSVFile || !readString) return;
    try {
        return readString(CSVFile, {
            worker: true
        });
    } catch (error) {
        return console.error(error);
    }
};
const convertAttendeesToCSV = (attendees, registrationFields, userRegistrationFields, additionalTickets, eventTickets, eventDiscounts)=>{
    const registrationFieldHeaders = registrationFields.filter((r)=>{
        return !!(r === null || r === void 0 ? void 0 : r.name);
    }).map((r)=>r.name);
    console.log({
        eventTickets,
        eventDiscounts
    });
    const headers = [
        "firstName",
        "lastName",
        "profileImage",
        "invitationSentDatetime",
        "email",
        ...additionalTickets && (additionalTickets === null || additionalTickets === void 0 ? void 0 : additionalTickets.length) > 0 ? [
            "ticketRegistrar"
        ] : [],
        ...eventDiscounts && (eventDiscounts === null || eventDiscounts === void 0 ? void 0 : eventDiscounts.length) > 0 ? [
            "discountCode"
        ] : [],
        ...eventTickets && (eventTickets === null || eventTickets === void 0 ? void 0 : eventTickets.length) > 0 ? [
            "totalPaid"
        ] : [],
        "ticketTitle",
        ...eventTickets && (eventTickets === null || eventTickets === void 0 ? void 0 : eventTickets.length) > 0 ? [
            "ticketType"
        ] : [],
        "registered",
        "checkInStatus",
        "checkInDatetime",
        ...!!registrationFields ? registrationFieldHeaders : []
    ];
    let csvArr = [
        headers.map((h)=>{
            var ref;
            // NOTE: Format headers to include a space between words.
            return (ref = toPascalCase(h)) === null || ref === void 0 ? void 0 : ref.replace(RegExp("(?<=.)[A-Z]", "g"), " $&").trim();
        }).join(",")
    ];
    for (let attendee of attendees){
        let row = [];
        let isGuest = Boolean(attendee.isAdditionalGuest);
        let discountCode;
        const orderInfo = additionalTickets === null || additionalTickets === void 0 ? void 0 : additionalTickets.find((ticket)=>ticket.guestTicketCode && attendee.ticketCode ? ticket.guestTicketCode === attendee.ticketCode : Boolean(ticket.guestTicketHolder && attendee.email && ticket.guestTicketHolder === attendee.email));
        const attendeeEventTicket = eventTickets === null || eventTickets === void 0 ? void 0 : eventTickets.find((f)=>{
            var ref, ref1;
            return (f === null || f === void 0 ? void 0 : (ref = f.title) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === (attendee === null || attendee === void 0 ? void 0 : (ref1 = attendee.ticketTitle) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
        });
        for (let header of headers){
            // if (header === 'ticketTitle') {
            //   console.log({
            //     header,
            //     val: attendee[header as keyof EventAttendee],
            //     attendee,
            //   })
            // }
            let value = attendee[header] || "";
            if (registrationFieldHeaders.includes(header)) {
                var ref, ref1;
                var ref2;
                value = attendee.isAdditionalGuest ? "" : (ref2 = (ref = userRegistrationFields === null || userRegistrationFields === void 0 ? void 0 : userRegistrationFields.find((r)=>r.email && attendee.email && r.email.toLowerCase() === attendee.email.toLowerCase())) === null || ref === void 0 ? void 0 : (ref1 = ref.registrationFields) === null || ref1 === void 0 ? void 0 : ref1[header]) !== null && ref2 !== void 0 ? ref2 : "N/A";
            }
            if ([
                "firstName",
                "lastName"
            ].includes(header) && !!attendee.name) {
                const [firstName, ...lastName] = attendee.name.split(" ");
                value = header === "firstName" ? firstName : lastName.join(" ");
            }
            if (header === "ticketRegistrar") {
                var ref3, ref4;
                value = (ref4 = (ref3 = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.primaryTicketHolder) !== null && ref3 !== void 0 ? ref3 : attendee.email) !== null && ref4 !== void 0 ? ref4 : "";
            }
            if (header === "discountCode") {
                const code = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.discountCode;
                if (code) discountCode = eventDiscounts === null || eventDiscounts === void 0 ? void 0 : eventDiscounts.find((f)=>f.code.toUpperCase() === code.toUpperCase());
                value = code !== null && code !== void 0 ? code : "N/A";
            }
            if (header === "totalPaid") {
                let total = 0;
                let ticketQuantity = 1;
                isGuest = isGuest || (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.primaryTicketHolder) !== undefined && (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.primaryTicketHolder) !== attendee.email;
                if (!!eventTickets) {
                    const ticket = attendeeEventTicket !== null && attendeeEventTicket !== void 0 ? attendeeEventTicket : eventTickets[0];
                    if (!!additionalTickets) {
                        const ticketOrder = additionalTickets === null || additionalTickets === void 0 ? void 0 : additionalTickets.filter((order)=>{
                            if (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.orderId) return order.orderId === orderInfo.orderId;
                            return order.primaryTicketHolder === attendee.email;
                        });
                        ticketQuantity = ticketOrder.length;
                    }
                    let price = ticket.price;
                    if (discountCode) {
                        if (discountCode.type === graphql/* DiscountType.BuyOneGetOneFree */.Lb.BuyOneGetOneFree) {
                            ticketQuantity = Math.ceil(ticketQuantity / 2);
                        }
                        if (discountCode.type === graphql/* DiscountType.Percentage */.Lb.Percentage) {
                            var _percentage;
                            price -= price * (((_percentage = discountCode.percentage) !== null && _percentage !== void 0 ? _percentage : 0) / 100);
                        }
                    }
                    total = price * ticketQuantity;
                // if (ticket.price > total || ticketQuantity === 0) isGuest = true
                }
                value = total.toFixed(2);
                if (isGuest) value = "GUEST";
            }
            if (header === "ticketType") {
                var ref5;
                value = (ref5 = attendeeEventTicket === null || attendeeEventTicket === void 0 ? void 0 : attendeeEventTicket.ticketType) !== null && ref5 !== void 0 ? ref5 : "N/A";
            }
            if ([
                "invitationSentDatetime",
                "checkInDatetime"
            ].includes(header)) {
                const date = attendee === null || attendee === void 0 ? void 0 : attendee[header];
                value = !!date ? moment_default()(date).format("DD-MM-YYYY hh:mm:ss") : "N/A";
            }
            row.push('"'.concat(value, '"'));
        }
        csvArr.push(row.join(","));
    }
    return csvArr.join("\r\n");
};
const getSymbol = (cr)=>{
    return cr ? currencies === null || currencies === void 0 ? void 0 : currencies[cr === null || cr === void 0 ? void 0 : cr.toUpperCase()].symbol : "\xa3";
};
const getAmount = (amount, cr)=>{
    if (!amount) return "";
    const value = typeof amount === "string" ? parseInt(amount, 10) : amount;
    return "".concat(getSymbol(cr !== null && cr !== void 0 ? cr : "")).concat((value / 100).toFixed(2));
};
const toPascalCase = (text)=>{
    var ref, ref1;
    return (ref1 = (ref = text === null || text === void 0 ? void 0 : text.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || ref === void 0 ? void 0 : ref.map((x)=>x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())) === null || ref1 === void 0 ? void 0 : ref1.join("");
};
const convertDonationToCSV = (donations)=>{
    const headers = [
        "amount",
        "firstName",
        "lastName",
        "donorDob",
        "currency",
        "message",
        "created",
        "datetime",
        "address",
        "coverFee",
        "donation",
        "fee",
        "giftAid",
        "selectedProgram",
        "email",
        "paymentType"
    ];
    let csvArr = [
        headers.join(",")
    ];
    for (let donation of donations){
        let row = [];
        for (let header of headers){
            let value = donation[header] || "";
            if (header === "paymentType") {
                value = !!donation.fee && !!donation.coverFee && !!donation.donation ? PaymentType.Card : PaymentType.DirectDebit;
            }
            if ([
                "amount",
                "donation",
                "fee"
            ].includes(header)) {
                value = getAmount(value, donation.currency);
            }
            row.push('"'.concat(value, '"'));
        }
        csvArr.push(row.join(","));
    }
    return csvArr.join("\r\n");
};

// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./components/base/ProfileImage.tsx
var ProfileImage = __webpack_require__(19527);
// EXTERNAL MODULE: ./components/inputs/InputPicker/InputPicker.tsx
var InputPicker = __webpack_require__(55369);
;// CONCATENATED MODULE: ./graphql/events/GetOrderByEventId.ts

const GET_ORDER_BY_EVENT_ID = (0,_generated/* graphql */.B)("\n  query getOrderByEventId($eventId: String!, $userId: String!) {\n    getOrderByEventId(eventId: $eventId, userId: $userId) {\n      userId\n      eventId\n      quantity\n      tickets {\n        title\n        email\n        fullName\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./graphql/events/GetOrderById.ts
var GetOrderById = __webpack_require__(31049);
;// CONCATENATED MODULE: ./graphql/users/setUserData.ts

const SET_USER_DATA = (0,_generated/* graphql */.B)("\n  mutation SetUserData($input: SetUserDataInput!) {\n    setUserData(input: $input)\n  }\n");

;// CONCATENATED MODULE: ./libs/dymoBadgePrinter.ts
const DYMO_SDK_URL = "https://cdn.jsdelivr.net/gh/dymosoftware/dymo-connect-framework@2182e505e334663bf79a48dea24800f2aebcfa98/dymo.connect.framework.js";
const BADGE_NAME_OBJECT = "BADGE_NAME";
const BADGE_ORGANISATION_OBJECT = "BADGE_ORGANISATION";
const BADGE_INDUSTRY_OBJECT = "BADGE_INDUSTRY";
// S0722430 / 99014: 101 mm x 54 mm; 30323 is DYMO's same-size DLS alias.
const BADGE_LABEL_XML = '<?xml version="1.0" encoding="utf-8"?>\n<DieCutLabel Version="8.0" Units="twips">\n  <PaperOrientation>Landscape</PaperOrientation>\n  <Id>NameBadge</Id>\n  <PaperName>30323 Shipping</PaperName>\n  <DrawCommands>\n    <RoundRectangle X="0" Y="0" Width="3061" Height="5726" Rx="120" Ry="120" />\n  </DrawCommands>\n  <ObjectInfo>\n    <TextObject>\n      <Name>'.concat(BADGE_NAME_OBJECT, '</Name>\n      <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n      <BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n      <LinkedObjectName></LinkedObjectName>\n      <Rotation>Rotation0</Rotation>\n      <IsMirrored>False</IsMirrored>\n      <IsVariable>True</IsVariable>\n      <HorizontalAlignment>Center</HorizontalAlignment>\n      <VerticalAlignment>Middle</VerticalAlignment>\n      <TextFitMode>ShrinkToFit</TextFitMode>\n      <UseFullFontHeight>True</UseFullFontHeight>\n      <Verticalized>False</Verticalized>\n      <StyledText>\n        <Element>\n          <String>Attendee name</String>\n          <Attributes>\n            <Font Family="Arial" Size="26" Bold="True" Italic="False" Underline="False" Strikeout="False" />\n            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n          </Attributes>\n        </Element>\n      </StyledText>\n    </TextObject>\n    <Bounds X="300" Y="200" Width="5126" Height="900" />\n  </ObjectInfo>\n  <ObjectInfo>\n    <TextObject>\n      <Name>').concat(BADGE_ORGANISATION_OBJECT, '</Name>\n      <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n      <BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n      <LinkedObjectName></LinkedObjectName>\n      <Rotation>Rotation0</Rotation>\n      <IsMirrored>False</IsMirrored>\n      <IsVariable>True</IsVariable>\n      <HorizontalAlignment>Center</HorizontalAlignment>\n      <VerticalAlignment>Middle</VerticalAlignment>\n      <TextFitMode>ShrinkToFit</TextFitMode>\n      <UseFullFontHeight>True</UseFullFontHeight>\n      <Verticalized>False</Verticalized>\n      <StyledText>\n        <Element>\n          <String>Organisation</String>\n          <Attributes>\n            <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False" />\n            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n          </Attributes>\n        </Element>\n      </StyledText>\n    </TextObject>\n    <Bounds X="300" Y="1200" Width="5126" Height="650" />\n  </ObjectInfo>\n  <ObjectInfo>\n    <TextObject>\n      <Name>').concat(BADGE_INDUSTRY_OBJECT, '</Name>\n      <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n      <BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n      <LinkedObjectName></LinkedObjectName>\n      <Rotation>Rotation0</Rotation>\n      <IsMirrored>False</IsMirrored>\n      <IsVariable>True</IsVariable>\n      <HorizontalAlignment>Center</HorizontalAlignment>\n      <VerticalAlignment>Middle</VerticalAlignment>\n      <TextFitMode>ShrinkToFit</TextFitMode>\n      <UseFullFontHeight>True</UseFullFontHeight>\n      <Verticalized>False</Verticalized>\n      <StyledText>\n        <Element>\n          <String>Industry</String>\n          <Attributes>\n            <Font Family="Arial" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />\n            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n          </Attributes>\n        </Element>\n      </StyledText>\n    </TextObject>\n    <Bounds X="300" Y="2050" Width="5126" Height="440" />\n  </ObjectInfo>\n</DieCutLabel>');
let dymoLoadPromise;
const normaliseFieldName = (value)=>value.toLowerCase().replace(/[^a-z0-9]/g, "");
const formatRegistrationValue = (value)=>{
    if (Array.isArray(value)) return value.map(String).join(", ");
    if (value === undefined || value === null) return undefined;
    if (typeof value === "object") return undefined;
    const formatted = String(value).trim();
    return formatted || undefined;
};
const findRegistrationValue = (fields, aliases)=>{
    if (!fields) return undefined;
    const match = Object.entries(fields).find((param)=>{
        let [name] = param;
        const normalisedName = normaliseFieldName(name);
        return aliases.some((alias)=>normalisedName.includes(alias));
    });
    return formatRegistrationValue(match === null || match === void 0 ? void 0 : match[1]);
};
const createBadgeData = (name, registrationFields)=>({
        name: name.trim() || "Unnamed attendee",
        organisation: findRegistrationValue(registrationFields, [
            "organisation",
            "organization",
            "company"
        ]),
        industry: findRegistrationValue(registrationFields, [
            "industry"
        ])
    });
const loadDymo = async ()=>{
    if (false) {}
    if (window.dymo) return window.dymo;
    if (dymoLoadPromise) return dymoLoadPromise;
    dymoLoadPromise = new Promise((resolve, reject)=>{
        const finish = ()=>{
            if (window.dymo) resolve(window.dymo);
            else reject(new Error("DYMO Connect SDK did not initialise."));
        };
        const existingScript = document.querySelector("script[data-forumm-dymo-sdk]");
        if (existingScript) {
            existingScript.addEventListener("load", finish, {
                once: true
            });
            existingScript.addEventListener("error", ()=>reject(new Error("Could not load DYMO Connect SDK.")), {
                once: true
            });
            return;
        }
        const script = document.createElement("script");
        script.src = DYMO_SDK_URL;
        script.async = true;
        script.dataset.forummDymoSdk = "true";
        script.addEventListener("load", finish, {
            once: true
        });
        script.addEventListener("error", ()=>reject(new Error("Could not load DYMO Connect SDK.")), {
            once: true
        });
        document.head.appendChild(script);
    });
    try {
        return await dymoLoadPromise;
    } catch (error) {
        dymoLoadPromise = undefined;
        throw error;
    }
};
const initialiseDymo = (framework)=>new Promise((resolve, reject)=>{
        const timeout = window.setTimeout(()=>reject(new Error("Timed out connecting to DYMO Connect.")), 10000);
        try {
            framework.init((environment)=>{
                window.clearTimeout(timeout);
                if (environment.isFrameworkInstalled) {
                    resolve();
                    return;
                }
                reject(new Error(environment.errorDetails || "DYMO Connect is not installed or its local service is unavailable."));
            });
        } catch (error) {
            window.clearTimeout(timeout);
            reject(error);
        }
    });
const printDymoBadge = async (badge)=>{
    const dymo = await loadDymo();
    const framework = dymo.label.framework;
    await initialiseDymo(framework);
    const printers = await framework.getLabelWriterPrintersAsync();
    const printer = printers.find((candidate)=>candidate.isConnected);
    if (!printer) throw new Error("No connected DYMO LabelWriter printer found.");
    const label = framework.openLabelXml(BADGE_LABEL_XML);
    if (!label.isValidLabel()) {
        throw new Error("DYMO rejected S0722430 badge label template.");
    }
    label.setObjectText(BADGE_NAME_OBJECT, badge.name);
    label.setObjectText(BADGE_ORGANISATION_OBJECT, badge.organisation || "");
    label.setObjectText(BADGE_INDUSTRY_OBJECT, badge.industry || "");
    await label.printAsync(printer.name);
    return printer.name;
};
const getBadgePrintedAt = (badgePrints, email)=>{
    var ref;
    return badgePrints === null || badgePrints === void 0 ? void 0 : badgePrints[(ref = email === null || email === void 0 ? void 0 : email.trim()) === null || ref === void 0 ? void 0 : ref.toLowerCase()];
};

// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
;// CONCATENATED MODULE: ./components/event/AttendeeModal.tsx


















var _ticketCode, ref, ref1;
const identityForAttendee = (attendee)=>(ref1 = (ref = (_ticketCode = attendee.ticketCode) !== null && _ticketCode !== void 0 ? _ticketCode : attendee.email) !== null && ref !== void 0 ? ref : attendee.orderId) !== null && ref1 !== void 0 ? ref1 : "";
const DetailItem = (param)=>/*#__PURE__*/ {
    let { icon , label , value , mono =false , style  } = param;
    return (0,jsx_runtime.jsxs)(Box["default"], {
        className: "min-w-0 rounded-xl border p-3",
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-center gap-2 text-xs font-semibold uppercase tracking-wide opacity-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": "true",
                        className: "text-base",
                        children: icon
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mt-2 break-words text-sm font-medium ".concat(mono ? "font-mono" : ""),
                children: value || "Not available"
            })
        ]
    });
};
const AttendeeModal = (param)=>{
    let { eventId , show , setShow , attendee , attendees , onCheckInChange , onPrintBadge , badgePrintingEnabled , badgePrints , refetchRegFields , regFieldsLoading , registrationFields , userRegistrationFields  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [setUserData] = (0,useMutation/* useMutation */.D)(SET_USER_DATA);
    const [editableFieldData, setEditableFieldData] = (0,react.useState)();
    const [isEditModalOpen, setEditModalOpen] = (0,react.useState)(false);
    const [data, setData] = (0,react.useState)();
    const [checkInLoadingIdentity, setCheckInLoadingIdentity] = (0,react.useState)();
    const [badgePrintLoadingIdentity, setBadgePrintLoadingIdentity] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        setData(undefined);
        setCheckInLoadingIdentity(undefined);
        setBadgePrintLoadingIdentity(undefined);
    }, [
        attendee === null || attendee === void 0 ? void 0 : attendee.ticketCode,
        attendee === null || attendee === void 0 ? void 0 : attendee.email,
        attendee === null || attendee === void 0 ? void 0 : attendee.orderId
    ]);
    (0,useQuery/* useQuery */.a)(GetOrderById/* GET_ORDER_BY_ID */.b, {
        variables: {
            orderId: attendee === null || attendee === void 0 ? void 0 : attendee.orderId
        },
        skip: !(attendee === null || attendee === void 0 ? void 0 : attendee.orderId),
        fetchPolicy: "network-only",
        onCompleted: (response)=>setData(response.getOrderById)
    });
    var ref;
    (0,useQuery/* useQuery */.a)(GET_ORDER_BY_EVENT_ID, {
        variables: {
            eventId,
            userId: (ref = attendee === null || attendee === void 0 ? void 0 : attendee.email) !== null && ref !== void 0 ? ref : ""
        },
        skip: !eventId || !(attendee === null || attendee === void 0 ? void 0 : attendee.email) || !!attendee.orderId,
        fetchPolicy: "network-only",
        onCompleted: (response)=>{
            return setData(response === null || response === void 0 ? void 0 : response.getOrderByEventId);
        }
    });
    const surfaceStyle = (0,react.useMemo)(()=>({
            backgroundColor: theme.backgroundColourSecondary,
            borderColor: theme.borderColour,
            color: theme.textColour
        }), [
        theme
    ]);
    if (!attendee) return null;
    const handleCheckInChange = async (targetAttendee, checkInStatus)=>{
        setCheckInLoadingIdentity(identityForAttendee(targetAttendee));
        try {
            await onCheckInChange(targetAttendee, checkInStatus);
        } finally{
            setCheckInLoadingIdentity(undefined);
        }
    };
    const handlePrintBadge = async (targetAttendee)=>{
        setBadgePrintLoadingIdentity(identityForAttendee(targetAttendee));
        try {
            await onPrintBadge(targetAttendee);
        } finally{
            setBadgePrintLoadingIdentity(undefined);
        }
    };
    const renderCheckInControl = function(targetAttendee) {
        let fullWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (!targetAttendee) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "text-sm text-slate-600 dark:text-slate-300",
            children: "Attendee unavailable"
        });
        const isPresent = targetAttendee.checkInStatus === "present";
        const identity = identityForAttendee(targetAttendee);
        const isLoading = checkInLoadingIdentity === identity;
        const isPrinting = badgePrintLoadingIdentity === identity;
        const badgePrintedAt = getBadgePrintedAt(badgePrints, identity);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-wrap items-center gap-2 ".concat(fullWidth ? "w-full justify-between" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-flex min-h-8 items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ".concat(isPresent ? "border-emerald-200 bg-emerald-100 text-emerald-800" : "border-slate-300 bg-slate-100 text-slate-700"),
                    children: [
                        isPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircleOutline */.GcF, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimeOutline */.dzk, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }),
                        isPresent ? "Checked in" : "Not checked in"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    disabled: isLoading || isPrinting,
                    className: "inline-flex min-h-10 cursor-pointer items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue disabled:cursor-not-allowed disabled:opacity-60 ".concat(isPresent ? "border-slate-300 bg-white text-slate-800 hover:bg-slate-100" : "border-emerald-700 bg-emerald-700 text-white hover:bg-emerald-800"),
                    onClick: ()=>handleCheckInChange(targetAttendee, isPresent ? "" : "present"),
                    children: [
                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                            size: "small"
                        }) : isPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoArrowUndoOutline */.gmZ, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircleOutline */.GcF, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }),
                        isPresent ? "Undo check-in" : "Check in"
                    ]
                }),
                isPresent && badgePrintingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    disabled: isLoading || isPrinting || regFieldsLoading,
                    className: "inline-flex min-h-10 cursor-pointer items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold text-white transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60 ".concat(badgePrintedAt ? "border-red-700 bg-red-700 hover:bg-red-800 focus-visible:ring-red-700" : "border-forumm-blue bg-forumm-blue hover:opacity-90 focus-visible:ring-forumm-blue"),
                    onClick: ()=>handlePrintBadge(targetAttendee),
                    children: [
                        isPrinting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                            size: "small"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPrintOutline */.U10, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }),
                        badgePrintedAt ? "Print again" : "Print badge"
                    ]
                }),
                badgePrintingEnabled && badgePrintedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-flex min-h-8 items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-100 px-2.5 py-1 text-xs font-semibold text-emerald-800",
                    title: "Printed ".concat(moment_default()(badgePrintedAt).format("DD MMM YYYY, HH:mm")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPrintOutline */.U10, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }),
                        "Badge printed"
                    ]
                })
            ]
        });
    };
    const getRegistrationFieldAnswer = (field)=>{
        var ref;
        const answers = (ref = userRegistrationFields.find((entry)=>entry.email === attendee.email)) === null || ref === void 0 ? void 0 : ref.registrationFields;
        const answerKey = answers ? Object.keys(answers).find((key)=>key.toLowerCase() === field.name.toLowerCase()) : undefined;
        const value = answerKey ? answers === null || answers === void 0 ? void 0 : answers[answerKey] : undefined;
        if (value === undefined || value === null || value === "") return "—";
        if (field.type === graphql/* FormInputType.Date */.Tx.Date) {
            const date = moment_default()(value);
            if (!date.isValid()) return String(value);
            return field.dateOnly ? date.format("DD/MM/YYYY") : date.format("DD/MM/YYYY HH:mm");
        }
        return String(value);
    };
    const handleFieldAnswerChange = async ()=>{
        var _userId;
        const userId = (_userId = attendee.userId) !== null && _userId !== void 0 ? _userId : attendee.email;
        if (!userId || !(editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.name)) return;
        var _answer;
        const response = await setUserData({
            variables: {
                input: {
                    userId,
                    eventId,
                    values: [
                        {
                            name: editableFieldData.name,
                            value: String((_answer = editableFieldData.answer) !== null && _answer !== void 0 ? _answer : "")
                        }
                    ]
                }
            }
        }).then((result)=>{
            var ref;
            return (ref = result.data) === null || ref === void 0 ? void 0 : ref.setUserData;
        });
        if (response) {
            dist/* default.success */.ZP.success("Registration answer updated.");
            setEditModalOpen(false);
            refetchRegFields();
        } else {
            dist/* default.error */.ZP.error("Could not update the registration answer.");
        }
    };
    const copyText = async (value, label)=>{
        try {
            await navigator.clipboard.writeText(value);
            dist/* default.success */.ZP.success("".concat(label, " copied."));
        } catch (_) {
            dist/* default.error */.ZP.error("Could not copy ".concat(label.toLowerCase(), "."));
        }
    };
    var ref1;
    const orderTickets = (ref1 = data === null || data === void 0 ? void 0 : data.tickets) !== null && ref1 !== void 0 ? ref1 : [];
    const orderAttendees = attendee.orderId ? attendees.filter((candidate)=>candidate.orderId === attendee.orderId) : [
        attendee
    ];
    const selectedOrderTicket = orderTickets.find((ticket)=>{
        var ref;
        return ticket.ticketCode && ticket.ticketCode === attendee.ticketCode || ticket.email && attendee.email && ticket.email.toLowerCase() === attendee.email.toLowerCase() && ticket.title.toLowerCase() === ((ref = attendee.ticketTitle) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    });
    const discountCode = selectedOrderTicket === null || selectedOrderTicket === void 0 ? void 0 : selectedOrderTicket.discountCode;
    const isPresent = attendee.checkInStatus === "present";
    var ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: "Edit registration answer",
                show: isEditModalOpen,
                setShow: setEditModalOpen,
                zIndex: "110",
                className: "!max-w-xl md:!min-w-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "space-y-4 pb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPicker/* InputPicker */.X, {
                            ukey: "registration_field_input",
                            type: (ref2 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.type) !== null && ref2 !== void 0 ? ref2 : graphql/* FormInputType.Text */.Tx.Text,
                            dateOnly: (ref3 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.dateOnly) !== null && ref3 !== void 0 ? ref3 : false,
                            validations: {
                                minLength: {
                                    value: 1,
                                    message: "The answer must contain at least one character"
                                }
                            },
                            value: (ref4 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.answer) !== null && ref4 !== void 0 ? ref4 : "",
                            onChange: (answer)=>setEditableFieldData((current)=>current ? {
                                        ...current,
                                        answer
                                    } : current),
                            required: (ref5 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.required) !== null && ref5 !== void 0 ? ref5 : false,
                            label: editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.name,
                            placeholder: "Enter ".concat((ref6 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.name) !== null && ref6 !== void 0 ? ref6 : "answer"),
                            options: (ref7 = editableFieldData === null || editableFieldData === void 0 ? void 0 : editableFieldData.options) !== null && ref7 !== void 0 ? ref7 : []
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex justify-end gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: ()=>setEditModalOpen(false),
                                    title: "Cancel",
                                    type: "secondary",
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: handleFieldAnswerChange,
                                    title: "Save answer",
                                    type: "primary",
                                    textColor: "white",
                                    size: "small"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: "Attendee information",
                show: show,
                setShow: setShow,
                className: "!max-w-5xl md:!min-w-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "space-y-5 pb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "rounded-2xl border p-4 sm:p-5",
                            style: surfaceStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex min-w-0 items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "shrink-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                                                    size: "lg",
                                                    imageUrl: attendee.profileImage
                                                }, identityForAttendee(attendee))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "truncate text-xl font-semibold sm:text-2xl",
                                                        children: attendee.name || "Unnamed attendee"
                                                    }),
                                                    attendee.email && !attendee.isAdditionalGuest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "mailto:".concat(attendee.email),
                                                        className: "mt-1 flex items-center gap-1.5 break-all text-sm text-forumm-blue hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoMailOutline */.WNJ, {
                                                                "aria-hidden": "true",
                                                                className: "h-4 w-4 shrink-0"
                                                            }),
                                                            attendee.email
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mt-1 text-sm opacity-70",
                                                        children: "Managed by registrar"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "mt-3 flex flex-wrap gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ".concat(attendee.registered ? "border-blue-200 bg-blue-100 text-blue-800" : "border-amber-200 bg-amber-100 text-amber-900"),
                                                                children: [
                                                                    attendee.registered ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircleOutline */.GcF, {
                                                                        "aria-hidden": "true"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloseCircleOutline */.Jvf, {
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    attendee.registered ? "Registered" : "Invitation pending"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ".concat(isPresent ? "border-emerald-200 bg-emerald-100 text-emerald-800" : "border-slate-300 bg-slate-100 text-slate-700"),
                                                                children: [
                                                                    isPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircleOutline */.GcF, {
                                                                        "aria-hidden": "true"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimeOutline */.dzk, {
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    isPresent ? "Checked in" : "Not checked in"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "w-full lg:w-auto",
                                        children: renderCheckInControl(attendee, true)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            "aria-labelledby": "ticket-details-heading",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mb-3 flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            id: "ticket-details-heading",
                                            className: "text-base font-semibold",
                                            children: "Ticket details"
                                        }),
                                        attendee.email && !attendee.isAdditionalGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex min-h-9 cursor-pointer items-center gap-2 rounded-lg px-3 py-1.5 text-sm font-semibold text-forumm-blue transition-colors hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue",
                                            onClick: ()=>copyText(attendee.email, "Email"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCopyOutline */.mcF, {
                                                    "aria-hidden": "true",
                                                    className: "h-4 w-4"
                                                }),
                                                "Copy email"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTicketOutline */.tvz, {}),
                                            label: "Ticket type",
                                            value: attendee.ticketTitle,
                                            style: surfaceStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTicketOutline */.tvz, {}),
                                            label: "Ticket code",
                                            value: attendee.ticketCode,
                                            mono: true,
                                            style: surfaceStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTicketOutline */.tvz, {}),
                                            label: "Discount code",
                                            value: discountCode !== null && discountCode !== void 0 ? discountCode : "None",
                                            mono: !!discountCode,
                                            style: surfaceStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimeOutline */.dzk, {}),
                                            label: "Last check-in activity",
                                            value: attendee.checkInDatetime ? moment_default()(attendee.checkInDatetime).format("DD MMM YYYY, HH:mm") : "No activity yet",
                                            style: surfaceStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimeOutline */.dzk, {}),
                                            label: "Order date",
                                            value: attendee.invitationSentDatetime ? moment_default()(attendee.invitationSentDatetime).format("DD MMM YYYY, HH:mm") : "Not available",
                                            style: surfaceStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonOutline */.FJ3, {}),
                                            label: "Order ID",
                                            value: attendee.orderId,
                                            mono: true,
                                            style: surfaceStyle
                                        })
                                    ]
                                })
                            ]
                        }),
                        orderAttendees.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            "aria-labelledby": "order-tickets-heading",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            id: "order-tickets-heading",
                                            className: "text-base font-semibold",
                                            children: "Tickets in this order"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-1 text-sm opacity-70",
                                            children: "Check in every guest independently from the primary ticket holder."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "space-y-2",
                                    children: orderAttendees.map((ticketAttendee, index)=>{
                                        var _email;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "grid gap-3 rounded-xl border p-3 sm:grid-cols-[minmax(0,1fr)_minmax(140px,0.7fr)_auto] sm:items-center",
                                            style: surfaceStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            className: "flex flex-wrap items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "truncate text-sm font-semibold",
                                                                    children: ticketAttendee.name || "Unnamed attendee"
                                                                }),
                                                                index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "rounded-full border border-blue-200 bg-blue-100 px-2 py-0.5 text-[11px] font-semibold text-blue-800",
                                                                    children: "Primary"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "mt-1 truncate text-xs opacity-70",
                                                            children: ticketAttendee.isAdditionalGuest ? "Managed by registrar" : (_email = ticketAttendee.email) !== null && _email !== void 0 ? _email : "—"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "text-sm font-medium",
                                                    children: ticketAttendee.ticketTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    children: renderCheckInControl(ticketAttendee)
                                                })
                                            ]
                                        }, identityForAttendee(ticketAttendee));
                                    })
                                })
                            ]
                        }),
                        !attendee.isAdditionalGuest && registrationFields.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            "aria-labelledby": "registration-fields-heading",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    id: "registration-fields-heading",
                                    className: "mb-3 text-base font-semibold",
                                    children: "Registration information"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "overflow-hidden rounded-xl border",
                                    style: {
                                        borderColor: theme.borderColour
                                    },
                                    children: registrationFields.map((field)=>{
                                        const answer = getRegistrationFieldAnswer(field);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex flex-col gap-2 border-b p-3 last:border-b-0 sm:flex-row sm:items-center sm:justify-between",
                                            style: surfaceStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-xs font-semibold uppercase tracking-wide opacity-70",
                                                            children: field.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "mt-1 break-words text-sm",
                                                            children: regFieldsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                                                size: "small"
                                                            }) : answer
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    onClick: ()=>{
                                                        setEditableFieldData({
                                                            ...field,
                                                            answer
                                                        });
                                                        setEditModalOpen(true);
                                                    },
                                                    title: "Edit",
                                                    type: "secondary",
                                                    size: "small",
                                                    disabled: regFieldsLoading,
                                                    className: "shrink-0"
                                                })
                                            ]
                                        }, field.name);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var event_AttendeeModal = (AttendeeModal);

// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
;// CONCATENATED MODULE: ./components/event/NotFoundModal.tsx





const NotFoundModal = (param)=>{
    let { ticketCode , show , setShow  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        setShow: setShow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "w-full relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-white text-center text-2xl font-bold pl-3 md:pl-0",
                    children: "Attendee not found"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 py-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-grow flex items-center justify-center p-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiUserX */.Ej3, {
                                    size: "8em"
                                })
                            }),
                            ticketCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    "Ticket Code: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-forumm-blue",
                                        children: ticketCode
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var event_NotFoundModal = (NotFoundModal);

// EXTERNAL MODULE: ./node_modules/@zxing/browser/esm/index.js + 219 modules
var esm = __webpack_require__(8819);
;// CONCATENATED MODULE: ./components/base/QRScanner.tsx






const QRScanner = (param)=>{
    let { onRead  } = param;
    const [isScanning, setIsScanning] = (0,react.useState)(false);
    const videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!isScanning) return;
        const codeReader = new esm/* BrowserQRCodeReader */.Nm();
        const startScanning = async ()=>{
            var ref, ref1;
            const devices = await esm/* BrowserQRCodeReader.listVideoInputDevices */.Nm.listVideoInputDevices();
            var ref2;
            const selectedDeviceId = (ref2 = devices === null || devices === void 0 ? void 0 : (ref = devices[1]) === null || ref === void 0 ? void 0 : ref.deviceId) !== null && ref2 !== void 0 ? ref2 : devices === null || devices === void 0 ? void 0 : (ref1 = devices[0]) === null || ref1 === void 0 ? void 0 : ref1.deviceId;
            if (videoRef.current) {
                const controls = await codeReader.decodeFromVideoDevice(selectedDeviceId, videoRef.current, (result, error, controls)=>{
                    if (result) {
                        setIsScanning(false);
                        onRead(result.getText());
                        controls.stop();
                    }
                    if (error) {
                        console.error(error);
                    }
                });
            }
        };
        startScanning();
    }, [
        isScanning,
        onRead
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !isScanning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    title: "Scan Ticket",
                    size: "auto",
                    // TODO: this should be visible, review it after.
                    // icon={<IoQrCodeOutline size="1.5em" />}
                    onClick: ()=>setIsScanning(!isScanning),
                    className: "ml-1 whitespace-nowrap"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: isScanning,
                title: "Attendee QR Code Verification",
                setShow: (val)=>{
                    setIsScanning(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "w-full relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-xs text-center mb-6",
                            children: "Please scan the attendee`s QR code from their registration confirmation."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            ref: videoRef
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var base_QRScanner = (QRScanner);

// EXTERNAL MODULE: ./graphql/events/GetOrdersByEventId.ts
var GetOrdersByEventId = __webpack_require__(31157);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
;// CONCATENATED MODULE: ./graphql/events/GetEventCodesById.ts

const GET_EVENT_CODES_BY_ID = (0,_generated/* graphql */.B)("\n  query getEventCodesById($input: GetEventByIdInput!) {\n    getEventById(input: $input) {\n      eventId\n      attendees {\n        email\n        name\n        orderId\n        ticketCode\n        badgePrintedAt\n      }\n      discounts {\n        quantity\n        title\n        tickets\n        type\n        code\n        percentage\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/components/AttendeeBox.gql.ts

const ATTENDEE_BOX_GET_USERS = (0,_generated/* graphql */.B)("\n  query GetUserMetadataForAttendeeBox(\n    $input: GetRegistrationFieldAnswersByEventIdInput!\n  ) {\n    getRegistrationFieldAnswersByEventId(input: $input) {\n      items {\n        name\n        email\n        userId\n        registrationVisible\n        registrationFields\n      }\n      total\n      nextToken\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/setCheckInforAttendee.ts

const SET_CHECKIN_FOR_ATTENDEE = (0,_generated/* graphql */.B)("\n	mutation setCheckInforAttendee (\n	  $email: String\n	  $ticketCode: String\n	  $eventId: String!\n      $checkInStatus: String!\n	) {\n	  setCheckInforAttendee (\n	    email: $email\n	    ticketCode: $ticketCode\n	    eventId: $eventId\n        checkInStatus: $checkInStatus\n	  )\n	}\n");

;// CONCATENATED MODULE: ./graphql/events/setBadgePrintedForAttendee.ts

const SET_BADGE_PRINTED_FOR_ATTENDEE = (0,_generated/* graphql */.B)("\n  mutation setBadgePrintedForAttendee(\n    $email: String\n    $ticketCode: String\n    $eventId: String!\n  ) {\n    setBadgePrintedForAttendee(\n      email: $email\n      ticketCode: $ticketCode\n      eventId: $eventId\n    )\n  }\n");

;// CONCATENATED MODULE: ./components/event/AttendeeList.tsx

















// import { debounce } from '@libs/Utility/util'

// import useWindowSize from '@libs/useWindowSize'









const BADGE_PRINTING_EVENT_ID = "e9b5be85-1f71-409b-8b4b-67d3700853f6";
var AttendeeList_ticketCode, _orderId, _name, AttendeeList_ref;
const attendeeIdentity = (attendee)=>(AttendeeList_ref = (AttendeeList_ticketCode = attendee.ticketCode) !== null && AttendeeList_ticketCode !== void 0 ? AttendeeList_ticketCode : attendee.email) !== null && AttendeeList_ref !== void 0 ? AttendeeList_ref : "".concat((_orderId = attendee.orderId) !== null && _orderId !== void 0 ? _orderId : "attendee", ":").concat((_name = attendee.name) !== null && _name !== void 0 ? _name : "");
const isEmailableAttendee = (attendee)=>{
    var ref;
    return Boolean(((ref = attendee.email) === null || ref === void 0 ? void 0 : ref.trim()) && !attendee.isAdditionalGuest);
};
const AttendeeList = (param)=>{
    let { eventId , event , refetchEvent , totalIncludingHidden =0 , hiddenAttendees =0  } = param;
    var ref, ref1, ref2;
    // console.log({ event })
    const { isOrganizer , isAdmin , profile  } = (0,useAuth/* useAuth */.aC)();
    const isPublished = event === null || event === void 0 ? void 0 : event.isPublished;
    var ref3;
    const registrationFields = ((ref3 = event === null || event === void 0 ? void 0 : event.registrationFields) !== null && ref3 !== void 0 ? ref3 : []).filter((f)=>!!f && !!f.name);
    const registrationFieldNames = registrationFields === null || registrationFields === void 0 ? void 0 : registrationFields.map((f)=>({
            name: f.name
        }));
    const attendees = event.attendees;
    var ref4;
    const invoiceTicketTitles = ((ref4 = event === null || event === void 0 ? void 0 : event.tickets) !== null && ref4 !== void 0 ? ref4 : []).filter((ticket)=>{
        return (ticket === null || ticket === void 0 ? void 0 : ticket.ticketType) === graphql/* TicketType.InvoiceTicket */.zK.InvoiceTicket;
    }).map((ticket)=>{
        var ref;
        return (ref = ticket.title) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    }).filter(Boolean);
    const canViewOrganizerInfo = isAdmin || isOrganizer;
    const badgePrintingEnabled = eventId === BADGE_PRINTING_EVENT_ID;
    var _userId;
    const userIds = attendees.filter((a)=>!!a.userId || !!a.email).map((a)=>(_userId = a.userId) !== null && _userId !== void 0 ? _userId : a.email).filter((id)=>Boolean(id));
    const [userRegistrationFields, setUserRegistrationFields] = (0,react.useState)([]);
    // NOTE: Get reg field answers for attendee list entries
    const { loading: regFieldsLoading , refetch: refetchRegFields  } = (0,useQuery/* useQuery */.a)(// GET_USERS_BY_IDS,
    ATTENDEE_BOX_GET_USERS, {
        variables: {
            input: {
                // userIds,
                eventId: eventId
            }
        },
        skip: !isAdmin && !isOrganizer || !((ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName),
        onCompleted: (data)=>{
            var _email;
            const currentAttendess = attendees.map((at)=>(_email = at.email) !== null && _email !== void 0 ? _email : at.userId).filter((id)=>Boolean(id));
            var ref;
            const attendessMetadata = data.getRegistrationFieldAnswersByEventId.items.filter((item)=>{
                var ref;
                const cond = (!!(item === null || item === void 0 ? void 0 : item.email) && currentAttendess.includes(item.email) || !!(item === null || item === void 0 ? void 0 : item.userId) && currentAttendess.includes(item.userId)) && // @ts-ignore
                Object.entries((ref = item === null || item === void 0 ? void 0 : item.registrationFields) !== null && ref !== void 0 ? ref : {}).length > 0;
                return cond;
            }).map((fd)=>{
                var ref1;
                return {
                    ...fd,
                    registrationFields: (ref = (ref1 = fd.registrationFields) === null || ref1 === void 0 ? void 0 : ref1[event.event.organizationName]) !== null && ref !== void 0 ? ref : fd.registrationFields
                };
            });
            const registrationFields = currentAttendess.map((at)=>{
                var ref, ref1;
                var ref2;
                return {
                    email: at,
                    registrationFields: (ref2 = (ref = attendessMetadata.filter((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.email) === at || (item === null || item === void 0 ? void 0 : item.userId) === at;
                    })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.registrationFields) !== null && ref2 !== void 0 ? ref2 : {}
                };
            });
            setUserRegistrationFields(registrationFields);
        }
    });
    // NOTE: Get order data for attendee list entries.
    const { data , loading: ordersLoading  } = (0,useQuery/* useQuery */.a)(GetOrdersByEventId/* GET_ORDERS_BY_EVENT_ID */.E, {
        variables: {
            eventId,
            userIds: userIds
        },
        skip: !eventId || userIds.length < 1 || !canViewOrganizerInfo,
        fetchPolicy: "network-only"
    });
    const { data: eventData , loading: eventLoading , refetch: refetchBadgePrints  } = (0,useQuery/* useQuery */.a)(GET_EVENT_CODES_BY_ID, {
        variables: {
            input: {
                eventId
            }
        },
        skip: !eventId || !(isOrganizer && ((ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName.toUpperCase()) === (profile === null || profile === void 0 ? void 0 : (ref2 = profile.company) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase())) && !isAdmin,
        fetchPolicy: "network-only",
        pollInterval: canViewOrganizerInfo ? 10000 : 0
    });
    // NOTE: Resend attendee invite email trigger.
    const [sendAttendeeEmailsForEvent] = (0,useMutation/* useMutation */.D)(SEND_ATTENDEE_EMAILS_FOR_EVENT);
    const [setCheckInforAttendee] = (0,useMutation/* useMutation */.D)(SET_CHECKIN_FOR_ATTENDEE);
    const [setBadgePrintedForAttendee] = (0,useMutation/* useMutation */.D)(SET_BADGE_PRINTED_FOR_ATTENDEE);
    const [allAttendees, setAllAttendees] = (0,react.useState)(attendees);
    const [filteredAttendees, setFilteredAttendees] = (0,react.useState)(attendees);
    const [selectedAttendee, setSelectedAttendee] = (0,react.useState)();
    const [additionalTickets, setAdditionalTickets] = (0,react.useState)([]);
    const [search, setSearch] = (0,react.useState)("");
    const [nameSortAsc, setNameSortAsc] = (0,react.useState)(true);
    const [emailSortAsc, setEmailSortAsc] = (0,react.useState)(true);
    const [loading, setLoading] = (0,react.useState)(false);
    const [checkInLoadingEmails, setCheckInLoadingEmails] = (0,react.useState)([]);
    const [badgePrintLoadingEmails, setBadgePrintLoadingEmails] = (0,react.useState)([]);
    const [badgePrints, setBadgePrints] = (0,react.useState)({});
    const [refreshing, setRefreshing] = (0,react.useState)(false);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [ticketCode, setTicketCode] = (0,react.useState)("");
    const [pendingTicketCode, setPendingTicketCode] = (0,react.useState)("");
    const [showNotFoundModal, setShowNotFoundModal] = (0,react.useState)(false);
    const [openedQr, setOpenedQr] = (0,react.useState)(false);
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    (0,react.useEffect)(()=>{
        var _attendees;
        const sharedBadgePrints = ((_attendees = eventData === null || eventData === void 0 ? void 0 : eventData.getEventById.attendees) !== null && _attendees !== void 0 ? _attendees : attendees).reduce((prints, attendee)=>{
            const identity = attendeeIdentity(attendee);
            const printedAt = attendee.badgePrintedAt;
            if (printedAt) prints[identity.trim().toLowerCase()] = printedAt;
            return prints;
        }, {});
        setBadgePrints(sharedBadgePrints);
    }, [
        attendees,
        eventData
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (attendees.length > 0 && !!(data === null || data === void 0 ? void 0 : data.getOrdersByEventId) && (data === null || data === void 0 ? void 0 : (ref = data.getOrdersByEventId) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            const payload = [];
            data.getOrdersByEventId.filter((f)=>!!f.paid).forEach((order)=>{
                var ref;
                const primaryTicketHolder = order.tickets[0];
                (ref = order.tickets) === null || ref === void 0 ? void 0 : ref.forEach((ticket)=>{
                    var _email, _ticketCode, ref, _isAdditionalGuest, ref1;
                    payload.push({
                        guestTicketHolder: (_email = ticket.email) !== null && _email !== void 0 ? _email : undefined,
                        guestTicketCode: (_ticketCode = ticket.ticketCode) !== null && _ticketCode !== void 0 ? _ticketCode : undefined,
                        primaryTicketHolder: (ref = primaryTicketHolder === null || primaryTicketHolder === void 0 ? void 0 : primaryTicketHolder.email) !== null && ref !== void 0 ? ref : undefined,
                        orderId: order.orderId,
                        isAdditionalGuest: (_isAdditionalGuest = ticket.isAdditionalGuest) !== null && _isAdditionalGuest !== void 0 ? _isAdditionalGuest : false,
                        discountCode: (ref1 = ticket === null || ticket === void 0 ? void 0 : ticket.discountCode) !== null && ref1 !== void 0 ? ref1 : undefined
                    });
                });
            });
            // console.log({ orderPayload: payload })
            setAdditionalTickets(payload);
        }
    }, [
        data,
        data === null || data === void 0 ? void 0 : data.getOrdersByEventId
    ]);
    const filterAttendees = function(searchText) {
        let attendeesToFilter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : allAttendees;
        const lowercasedSearchText = searchText.toLowerCase();
        return attendeesToFilter.filter((attendee)=>{
            var ref, ref1;
            return (attendee === null || attendee === void 0 ? void 0 : (ref = attendee.name) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(lowercasedSearchText)) || ((ref1 = attendee.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(lowercasedSearchText));
        });
    };
    (0,react.useEffect)(()=>{
        const lowercasedSearchText = search.toLowerCase();
        const updatedFilteredAttendees = search ? attendees.filter((attendee)=>{
            var ref, ref1;
            return (attendee === null || attendee === void 0 ? void 0 : (ref = attendee.name) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(lowercasedSearchText)) || ((ref1 = attendee.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(lowercasedSearchText));
        }) : attendees;
        setAllAttendees(attendees);
        setFilteredAttendees(updatedFilteredAttendees);
        setSelectedAttendee((currentSelectedAttendee)=>{
            if (!currentSelectedAttendee) return currentSelectedAttendee;
            var ref;
            return (ref = attendees.find((attendee)=>attendeeIdentity(attendee) === attendeeIdentity(currentSelectedAttendee))) !== null && ref !== void 0 ? ref : currentSelectedAttendee;
        });
    // Search already filters the current local attendees in handleSearch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        attendees
    ]);
    const ticketCodesLoaded = allAttendees.some((attendee)=>!!attendee.ticketCode);
    const handleTicketCode = (0,react.useCallback)(function(text) {
        let deferUntilTicketCodesLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        setTicketCode(text);
        setOpenedQr(true);
        const matchingAttendee = allAttendees.find((param)=>{
            let { ticketCode  } = param;
            return ticketCode === text;
        });
        if (matchingAttendee) {
            setPendingTicketCode("");
            handlePressAttendee(matchingAttendee);
        } else if (text && deferUntilTicketCodesLoad && !ticketCodesLoaded) {
            setPendingTicketCode(text);
        } else {
            setPendingTicketCode("");
            setShowNotFoundModal(true);
        }
    }, [
        allAttendees,
        ticketCodesLoaded
    ]);
    (0,react.useEffect)(()=>{
        if (!pendingTicketCode || !ticketCodesLoaded) return;
        handleTicketCode(pendingTicketCode, false);
    }, [
        handleTicketCode,
        pendingTicketCode,
        ticketCodesLoaded
    ]);
    (0,react.useEffect)(()=>{
        if (openedQr) return;
        if (allAttendees && allAttendees.length > 0) {
            const params = new URLSearchParams(window.location.search);
            const ticketCodeParam = params.get("ticketCode");
            if (ticketCodeParam) {
                handleTicketCode(ticketCodeParam);
            }
        }
    }, [
        openedQr,
        allAttendees,
        handleTicketCode
    ]);
    const handleOnQrRead = (text)=>{
        try {
            const url = new URL(text);
            const params = new URLSearchParams(url.search);
            const code = params.get("ticketCode");
            if (code) {
                if (!text.includes(eventId)) {
                    window.location.href = text;
                    return;
                }
                handleTicketCode(code);
            } else {
                handleTicketCode("", false);
            }
        } catch (error) {
            handleTicketCode("", false);
            console.error("Invalid URL:", error);
            return null;
        }
    };
    const handleSearch = (text)=>{
        setSearch(text);
        setFilteredAttendees(filterAttendees(text));
    };
    const handleRefresh = async ()=>{
        setRefreshing(true);
        try {
            await Promise.all([
                refetchEvent(),
                refetchRegFields(),
                refetchBadgePrints()
            ]);
        } catch (error) {
            console.error("Failed to refresh attendees:", error);
            (0,dist/* default */.ZP)("Failed to refresh attendee list.", {
                icon: "❌",
                duration: 8000,
                className: "custom-toast"
            });
        } finally{
            setRefreshing(false);
        }
    };
    const sortAttendees = (attendees, field, asc)=>{
        return attendees.sort((a, b)=>{
            if (asc) {
                return String(a[field]).localeCompare(String(b[field]));
            }
            return String(b[field]).localeCompare(String(a[field]));
        });
    };
    const handleSortName = ()=>{
        setNameSortAsc(!nameSortAsc);
        setFilteredAttendees(sortAttendees([
            ...filteredAttendees
        ], "name", !nameSortAsc));
    };
    const handleSortEmail = ()=>{
        setEmailSortAsc(!emailSortAsc);
        setFilteredAttendees(sortAttendees([
            ...filteredAttendees
        ], "email", !emailSortAsc));
    };
    const sendInvitations = async (attendees)=>{
        setLoading(true);
        await sendAttendeeEmailsForEvent({
            variables: {
                emails: attendees,
                eventId: eventId
            }
        });
        const updatedAttendees = [
            ...allAttendees
        ].map((attendee)=>attendee.email && attendees.includes(attendee.email) ? {
                ...attendee,
                resentMessage: "Email Resent"
            } : attendee);
        setAllAttendees(updatedAttendees);
        setFilteredAttendees(updatedAttendees);
        setSearch("");
        setLoading(false);
    };
    const handleResend = (attendee)=>{
        if (isEmailableAttendee(attendee)) sendInvitations([
            attendee.email
        ]);
    };
    const updateLocalCheckInStatus = (identity, checkInStatus, checkInDatetime)=>{
        const updateAttendee = (attendee)=>attendeeIdentity(attendee) === identity ? {
                ...attendee,
                checkInStatus,
                checkInDatetime
            } : attendee;
        setAllAttendees((currentAttendees)=>currentAttendees.map(updateAttendee));
        setFilteredAttendees((currentAttendees)=>currentAttendees.map(updateAttendee));
        setSelectedAttendee((currentAttendee)=>currentAttendee ? updateAttendee(currentAttendee) : currentAttendee);
    };
    const handleCheckInChange = async (attendee, checkInStatus)=>{
        const identity = attendeeIdentity(attendee);
        setCheckInLoadingEmails((currentEmails)=>[
                ...currentEmails,
                identity
            ]);
        try {
            await setCheckInforAttendee({
                variables: {
                    email: attendee.ticketCode ? undefined : attendee.email,
                    ticketCode: attendee.ticketCode,
                    eventId,
                    checkInStatus
                }
            });
            updateLocalCheckInStatus(identity, checkInStatus, checkInStatus === "present" ? new Date().toISOString() : undefined);
        } catch (error) {
            console.error("Failed to update attendee check-in status:", error);
            (0,dist/* default */.ZP)("Failed to update check-in status.", {
                icon: "❌",
                duration: 8000,
                className: "custom-toast"
            });
        } finally{
            setCheckInLoadingEmails((currentEmails)=>currentEmails.filter((email)=>email !== identity));
        }
    };
    const handlePrintBadge = async (attendee)=>{
        const identity = attendeeIdentity(attendee);
        setBadgePrintLoadingEmails((currentEmails)=>[
                ...currentEmails,
                identity
            ]);
        try {
            var ref;
            const registrationFields = (ref = userRegistrationFields.find((entry)=>{
                var ref;
                return !!attendee.email && ((ref = entry.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === attendee.email.toLowerCase();
            })) === null || ref === void 0 ? void 0 : ref.registrationFields;
            const badge = createBadgeData(attendee.name || attendee.email || "Unnamed attendee", registrationFields);
            const printerName = await printDymoBadge(badge);
            const printedAt = new Date().toISOString();
            setBadgePrints((currentPrints)=>({
                    ...currentPrints,
                    [identity.trim().toLowerCase()]: printedAt
                }));
            let statusSaved = false;
            try {
                statusSaved = Boolean(await setBadgePrintedForAttendee({
                    variables: {
                        email: attendee.ticketCode ? undefined : attendee.email,
                        ticketCode: attendee.ticketCode,
                        eventId
                    }
                }).then((result)=>{
                    var ref;
                    return (ref = result.data) === null || ref === void 0 ? void 0 : ref.setBadgePrintedForAttendee;
                }));
            } catch (error) {
                console.error("Failed to share badge printed status:", error);
            }
            if (!statusSaved) {
                dist/* default.error */.ZP.error("Badge sent to ".concat(printerName, ", but its printed status could not be shared with other staff."));
                return;
            }
            dist/* default.success */.ZP.success("Badge sent to ".concat(printerName, "."));
        } catch (error1) {
            console.error("Failed to print attendee badge:", error1);
            dist/* default.error */.ZP.error(error1 instanceof Error ? error1.message : "Failed to print badge.");
        } finally{
            setBadgePrintLoadingEmails((currentEmails)=>currentEmails.filter((currentIdentity)=>currentIdentity !== identity));
        }
    };
    const handleResendAll = ()=>{
        const pendingAttendess = allAttendees.filter((attendee)=>!attendee.resentMessage && !attendee.registered && isEmailableAttendee(attendee)).map((attendee)=>attendee.email).filter((email)=>Boolean(email));
        sendInvitations(pendingAttendess);
    };
    const formatDate = (date)=>{
        if (!date) return "";
        return moment_default()(date).format("MMM DD, H:mmA");
    };
    const getStatusMessage = (attendee)=>{
        if (attendee === null || attendee === void 0 ? void 0 : attendee.resentMessage) {
            return attendee.resentMessage;
        }
        if (isPublished) {
            if (attendee.registered) {
                return "Registered";
            }
            const dateMessage = (attendee === null || attendee === void 0 ? void 0 : attendee.invitationSentDatetime) ? formatDate(attendee === null || attendee === void 0 ? void 0 : attendee.invitationSentDatetime) : null;
            if (dateMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Sent ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        dateMessage
                    ]
                });
            }
            return "Sent";
        }
        return "Not sent yet";
    };
    const handlePressAttendee = (attendee)=>{
        setSelectedAttendee(attendee);
        setShowModal(true);
    };
    const pendingAttendees = allAttendees.filter((attendee)=>!attendee.registered && isEmailableAttendee(attendee));
    if (!attendees || attendees.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                children: "No attendees have been added for this event yet. Check back soon!"
            })
        });
    }
    var ref5;
    const numberOfAttendees = totalIncludingHidden || ((ref5 = attendees === null || attendees === void 0 ? void 0 : attendees.length) !== null && ref5 !== void 0 ? ref5 : 0);
    const markedAsPresent = allAttendees.filter((param)=>{
        let { checkInStatus  } = param;
        return checkInStatus == "present";
    }).length;
    const notCheckedIn = allAttendees.filter((param)=>{
        let { checkInStatus  } = param;
        return checkInStatus !== "present";
    }).length;
    // const [fetchOrder] = useLazyQuery(GET_ORDER_BY_ID, {
    //   fetchPolicy: 'network-only',
    // })
    const getOrder = async (attendee)=>{
        if (!attendee.orderId) return null;
        // const order = await fetchOrder({
        //   variables: { orderId: attendee.orderId },
        // }).then((d) => ({ ...d.data?.getOrderById, orderId: attendee.orderId! }))
        if (!loading && !!(data === null || data === void 0 ? void 0 : data.getOrdersByEventId) && data.getOrdersByEventId.length > 0) {
            const order = data.getOrdersByEventId.find((o)=>o.orderId === attendee.orderId || o.userId === attendee.userId);
            // console.log({ order })
            return order;
        }
        return null;
    };
    const downloadCSV = async function() {
        let targetAttendees = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : allAttendees, filename = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "attendees.csv";
        var ref;
        var ref1, ref2;
        // const attendeesWithOrders: EventAttandeeWithOrder[] = await Promise.all(
        //   attendees.map(async (at, index) => {
        //     const order = await getOrder(at)
        //
        //     if (order) return { ...at, order }
        //     return { ...at }
        //   })
        // )
        // console.log({ eventData, additionalTickets })
        const csv = convertAttendeesToCSV(targetAttendees, registrationFieldNames, userRegistrationFields, additionalTickets, (ref1 = event === null || event === void 0 ? void 0 : event.tickets) !== null && ref1 !== void 0 ? ref1 : [], (ref2 = eventData === null || eventData === void 0 ? void 0 : (ref = eventData.getEventById) === null || ref === void 0 ? void 0 : ref.discounts) !== null && ref2 !== void 0 ? ref2 : []);
        const blob = new Blob([
            "\uFEFF" + csv
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const downloadInvoiceCSV = ()=>{
        const invoiceAttendees = allAttendees.filter((attendee)=>{
            var ref;
            return invoiceTicketTitles.includes((ref = attendee.ticketTitle) === null || ref === void 0 ? void 0 : ref.toUpperCase());
        });
        downloadCSV(invoiceAttendees, "invoice-ticket-attendees.csv");
    };
    const getCheckInStatusLabel = (checkInStatus)=>{
        if (checkInStatus === "present") return "Present";
        return "No activity";
    };
    const renderCheckInControls = (attendee)=>{
        const identity = attendeeIdentity(attendee);
        const isLoading = checkInLoadingEmails.includes(identity);
        const isPrinting = badgePrintLoadingEmails.includes(identity);
        const isPresent = attendee.checkInStatus === "present";
        const badgePrintedAt = getBadgePrintedAt(badgePrints, identity);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "capitalize ".concat(isPresent ? "text-green-500" : ""),
                    children: getCheckInStatusLabel(attendee.checkInStatus)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-wrap gap-2",
                    children: [
                        !isPresent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: "Check In",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircleOutline */.GcF, {
                                size: "1em"
                            }),
                            type: "success",
                            size: "small",
                            loading: isLoading,
                            disabled: isLoading,
                            onClick: ()=>handleCheckInChange(attendee, "present"),
                            className: "whitespace-nowrap"
                        }),
                        isPresent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    title: "Undo",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoArrowUndoOutline */.gmZ, {
                                        size: "1em"
                                    }),
                                    size: "small",
                                    loading: isLoading,
                                    disabled: isLoading || isPrinting,
                                    onClick: ()=>handleCheckInChange(attendee, ""),
                                    className: "whitespace-nowrap"
                                }),
                                badgePrintingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    title: badgePrintedAt ? "Print Again" : "Print Badge",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPrintOutline */.U10, {
                                        size: "1em"
                                    }),
                                    type: badgePrintedAt ? "danger" : "primary",
                                    backgroundColor: badgePrintedAt ? "#dc2626" : undefined,
                                    textColor: badgePrintedAt ? "#ffffff" : undefined,
                                    size: "small",
                                    loading: isPrinting,
                                    disabled: isLoading || isPrinting || regFieldsLoading,
                                    onClick: ()=>handlePrintBadge(attendee),
                                    className: "whitespace-nowrap"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var _email;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        value: search,
                        className: "w-full",
                        label: "",
                        placeholder: "Enter your search terms",
                        onChange: handleSearch
                    }),
                    canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Refresh",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRefreshOutline */.TgK, {
                            size: "1em"
                        }),
                        loading: refreshing,
                        disabled: refreshing,
                        onClick: handleRefresh,
                        size: "large",
                        className: "whitespace-nowrap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_QRScanner, {
                        onRead: handleOnQrRead
                    })
                ]
            }),
            pendingAttendees.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-3 flex items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-link hover:underline cursor-pointer",
                        onClick: handleResendAll,
                        children: "Resend pending invites"
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                        className: "mt-1",
                        size: "small"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full pt-5 text-xs sm:text-sm ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    color: "backgroundColourSecondary",
                    className: "grid grid-cols-3 my-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            color: "backgroundColourSecondary",
                            className: "p-3 border-l-8 border-l-blue-500 text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "",
                                    children: "Total Registered: "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: numberOfAttendees
                                })
                            ]
                        }),
                        canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "p-3 text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "",
                                    children: "Marked as Present: "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green-500",
                                    children: markedAsPresent
                                })
                            ]
                        }),
                        canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "p-3 border-r-8 text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "",
                                    children: "Not Checked In: "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: notCheckedIn
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                color: "backgroundColourSecondary",
                className: "\n          grid col-span-4 grid-cols-4 border-collapse text-[9px] sm:text-sm\n          ".concat(canViewOrganizerInfo ? "md:col-span-5 md:grid-cols-5" : "md:col-span-1 md:grid-cols-1", "\n        "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "p-2 md:p-7 border border-forumm-menu-border cursor-pointer",
                        onClick: handleSortName,
                        children: [
                            "Full Name ",
                            nameSortAsc ? "↓" : "↑"
                        ]
                    }),
                    canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "p-2 md:p-7 border border-forumm-menu-border cursor-pointer",
                        onClick: handleSortEmail,
                        children: [
                            "Email ",
                            emailSortAsc ? "↓" : "↑"
                        ]
                    }),
                    canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "p-2 md:p-7 border border-forumm-menu-border",
                        children: "Check-in Status"
                    }),
                    canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "p-2 md:p-7 border border-forumm-menu-border hidden md:block",
                        children: "Reminder"
                    }),
                    canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "p-2 md:p-7 border border-forumm-menu-border",
                        children: "View More Info"
                    }),
                    filteredAttendees.map((attendee, i)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                            className: "grid col-span-4 grid-cols-4 border-forumm-menu-border border-2 -mt-1\n                        ".concat(canViewOrganizerInfo ? "md:col-span-5 md:grid-cols-5" : "md:col-span-1 md:grid-cols-1", "\n              "),
                            style: {
                                background: theme.backgroundColourSecondary
                            },
                            whileHover: {
                                scale: 1.02
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "p-2 md:p-7 mt-2 cursor-pointer text-[9px] sm:text-sm",
                                    onClick: ()=>handlePressAttendee(attendee),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: attendee === null || attendee === void 0 ? void 0 : attendee.name
                                        }),
                                        badgePrintingEnabled && getBadgePrintedAt(badgePrints, attendeeIdentity(attendee)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "mt-1 flex items-center gap-1 text-[8px] font-semibold text-green-600 sm:text-xs",
                                            title: "Printed ".concat(moment_default()(getBadgePrintedAt(badgePrints, attendeeIdentity(attendee))).format("DD MMM YYYY, HH:mm")),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPrintOutline */.U10, {
                                                    "aria-hidden": "true"
                                                }),
                                                "Badge printed"
                                            ]
                                        })
                                    ]
                                }),
                                canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "p-2 md:p-7 text-[9px] sm:text-sm mt-2 cursor-pointer overflow-auto word-wrap",
                                    onClick: ()=>handlePressAttendee(attendee),
                                    children: attendee.isAdditionalGuest ? "Managed by registrar" : (_email = attendee.email) !== null && _email !== void 0 ? _email : "—"
                                }),
                                canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "p-2 md:p-7 text-[9px] sm:text-sm mt-2",
                                    children: renderCheckInControls(attendee)
                                }),
                                canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "p-2 md:p-7 text-[9px] sm:text-sm mt-2 hidden md:block",
                                    children: attendee.isAdditionalGuest ? "Managed by registrar" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            !attendee.registered && !attendee.resentMessage && isEmailableAttendee(attendee) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                title: "Resend",
                                                type: "modal",
                                                size: "small",
                                                onClick: ()=>handleResend(attendee)
                                            }),
                                            attendee.registered && "Registered",
                                            !attendee.registered && attendee.resentMessage && "Invitation Resent!"
                                        ]
                                    })
                                }),
                                canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "p-2 md:p-7 mt-2 cursor-pointer",
                                    onClick: ()=>handlePressAttendee(attendee),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        title: "i",
                                        size: "auto",
                                        className: "text-white text-[9px] sm:text-sm p-0",
                                        onClick: ()=>handlePressAttendee(attendee)
                                    })
                                })
                            ]
                        }, attendeeIdentity(attendee));
                    })
                ]
            }),
            canViewOrganizerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "w-full flex items-center justify-between pt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex text-center pl-3 md:pl-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Export CSV",
                                size: "auto",
                                // TODO: this should be visible, review it after.
                                // icon={<IoDownloadOutline size="1.5em" />}
                                onClick: ()=>downloadCSV(),
                                className: "ml-2 text-white whitespace-nowrap",
                                loading: regFieldsLoading || ordersLoading || eventLoading
                            }),
                            invoiceTicketTitles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Export Invoice CSV",
                                size: "auto",
                                onClick: downloadInvoiceCSV,
                                className: "ml-2 text-white whitespace-nowrap",
                                loading: regFieldsLoading || ordersLoading || eventLoading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_QRScanner, {
                        onRead: handleOnQrRead
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(event_AttendeeModal, {
                eventId: eventId,
                show: showModal,
                setShow: setShowModal,
                attendee: selectedAttendee,
                attendees: allAttendees,
                regFieldsLoading: regFieldsLoading,
                registrationFields: registrationFields,
                userRegistrationFields: userRegistrationFields,
                onCheckInChange: handleCheckInChange,
                onPrintBadge: handlePrintBadge,
                badgePrintingEnabled: badgePrintingEnabled,
                badgePrints: badgePrints,
                refetchRegFields: refetchRegFields
            }, selectedAttendee ? attendeeIdentity(selectedAttendee) : undefined),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(event_NotFoundModal, {
                ticketCode: ticketCode,
                show: showNotFoundModal,
                setShow: setShowNotFoundModal
            }, ticketCode)
        ]
    });
};

;// CONCATENATED MODULE: ./components/event/AttendeeBox.tsx







const AttendeeBox = (param)=>{
    let { eventId , event , show =true  } = param;
    var ref;
    const { isOrganizer , isAdmin  } = (0,useAuth/* useAuth */.aC)();
    var ref1;
    const registrationFields = ((ref1 = event === null || event === void 0 ? void 0 : event.registrationFields) !== null && ref1 !== void 0 ? ref1 : []).filter((f)=>!!f && !!f.name);
    const attendees = event.attendees;
    const [userRegistrationFields, setUserRegistrationFields] = (0,react.useState)();
    const { data , loading: regFieldsLoading  } = (0,useQuery/* useQuery */.a)(ATTENDEE_BOX_GET_USERS, {
        variables: {
            input: {
                eventId
            }
        }
    });
    const [localAttendees, setLocalAttendees] = (0,react.useState)(attendees);
    const SPECIAL_CASE_OF_EXTERNAL_ONLY_APPLY_FOR_EVENTS = [
        "59080128-59d6-4164-a824-0e48b01ef75f",
        "2af2f67c-57aa-4b6a-b89e-dc46c3a1333a",
        "a37735e2-95e0-47ee-b5e9-1ce852c27cae"
    ];
    (0,react.useEffect)(()=>{
        // console.log({
        //   data,
        // })
        if (data) {
            var _email;
            const currentAttendess = attendees.map((at)=>(_email = at.email) !== null && _email !== void 0 ? _email : at.userId).filter((id)=>Boolean(id));
            var ref;
            const attendessMetadata = data.getRegistrationFieldAnswersByEventId.items.filter((item)=>{
                var ref;
                const cond = (!!(item === null || item === void 0 ? void 0 : item.email) && currentAttendess.includes(item.email) || !!item.userId && currentAttendess.includes(item === null || item === void 0 ? void 0 : item.userId)) && // @ts-ignore
                Object.entries((ref = item === null || item === void 0 ? void 0 : item.registrationFields) !== null && ref !== void 0 ? ref : {}).length > 0;
                return cond;
            }).map((fd)=>{
                var ref1;
                return {
                    ...fd,
                    registrationFields: (ref = (ref1 = fd.registrationFields) === null || ref1 === void 0 ? void 0 : ref1[event.organisationName]) !== null && ref !== void 0 ? ref : fd.registrationFields
                };
            });
            // console.log({ currentAttendess, attendessMetadata })
            const registrationFields = currentAttendess.map((at)=>{
                var ref, ref1;
                var ref2;
                const payload = {
                    id: at,
                    registrationFields: (ref2 = (ref = attendessMetadata.filter((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.email) === at || (item === null || item === void 0 ? void 0 : item.userId) === at;
                    })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.registrationFields) !== null && ref2 !== void 0 ? ref2 : {}
                };
                return payload;
            });
            // console.log({ registrationFields })
            setUserRegistrationFields(registrationFields);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (!regFieldsLoading && !!userRegistrationFields && userRegistrationFields.length > 0) {
            const updatedAttendees = attendees.map((attendee)=>{
                var _email;
                const matchedUser = userRegistrationFields.find((user)=>user.id === ((_email = attendee.email) !== null && _email !== void 0 ? _email : attendee.userId));
                if (!(matchedUser === null || matchedUser === void 0 ? void 0 : matchedUser.registrationFields)) return attendee;
                const visibleFields = Object.entries(matchedUser === null || matchedUser === void 0 ? void 0 : matchedUser.registrationFields).reduce((acc, param)=>{
                    let [key, value] = param;
                    const fieldDef = registrationFields.find((f)=>f.name === key && f.visibleOnAttendeeList);
                    if (fieldDef) acc[key] = value;
                    return acc;
                }, {});
                return {
                    ...attendee,
                    registrationFields: visibleFields
                };
            });
            setLocalAttendees(updatedAttendees);
        }
    }, [
        userRegistrationFields
    ]);
    if (!show || !regFieldsLoading && (localAttendees === null || localAttendees === void 0 ? void 0 : localAttendees.length) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        color: "foregroundColour",
        className: "w-full p-10 max-w-md border border-forumm-menu-border rounded-2xl flex flex-col flex-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl font-medium",
                children: "Attendees"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-sm text-gray-600",
                    children: [
                        "Total Registered: ",
                        (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.length
                    ]
                })
            }),
            regFieldsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "space-y-4 max-h-[100vh] overflow-y-auto scrollbar-custom flex-1 h-[100%]",
                children: localAttendees.filter((attendee)=>attendee.registrationVisible === true || event.organisationName.toLowerCase() === "university of glasgow").sort((a, b)=>{
                    if (!a.name || !b.name) return 0;
                    return a.name.localeCompare(b.name);
                }).map((attendee, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col border-b pb-6 last:border-b-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex items-center space-x-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-medium mt-4 text-lg ml-2",
                                        children: attendee.name
                                    })
                                })
                            }),
                            attendee.registrationFields && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "-mt-4 text-sm text-gray-60",
                                children: Object.entries(attendee.registrationFields).map((param)=>/*#__PURE__*/ {
                                    let [key, value] = param;
                                    return (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm text-gray-600 capitalize"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm text-gray-600 capitalize",
                                                children: value
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var event_AttendeeBox = (AttendeeBox);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 10 modules
var Wrapper = __webpack_require__(41702);
// EXTERNAL MODULE: ./components/base/TextLink.tsx
var TextLink = __webpack_require__(82316);
;// CONCATENATED MODULE: ./graphql/users/me.ts

const ME = (0,_generated/* graphql */.B)("\n  query Me {\n    me {\n      ...UserFull\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./graphql/users/updateEvent.ts

const ADD_USER_DATA = (0,_generated/* graphql */.B)("\n  mutation AddUserData($input: RegistrationFieldValuesInput!) {\n    addUserData(input: $input)\n  }\n");

// EXTERNAL MODULE: ./components/event/EventDateTime.tsx
var EventDateTime = __webpack_require__(39889);
;// CONCATENATED MODULE: ./components/event/SpeakerModal.tsx








const SpeakerModal = (param)=>{
    let { show , setShow , speaker  } = param;
    const { StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    let socialNetworks = {
        facebookAccount: "",
        instagramAccount: "",
        linkedinAccount: "",
        twitterAccount: ""
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        closeButton: true,
        show: show,
        setShow: setShow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex space-x-8 text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                        imageUrl: speaker === null || speaker === void 0 ? void 0 : speaker.profileImage,
                        activityStatus: true,
                        size: "lg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col space-y-2 text-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "font-bold text-xl",
                                children: speaker === null || speaker === void 0 ? void 0 : speaker.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBusiness */.UQs, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (ref = speaker === null || speaker === void 0 ? void 0 : speaker.organization) !== null && ref !== void 0 ? ref : speaker === null || speaker === void 0 ? void 0 : speaker.organization,
                                            (speaker === null || speaker === void 0 ? void 0 : speaker.position) ? " - ".concat(speaker === null || speaker === void 0 ? void 0 : speaker.position) : ""
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex items-center justify-center text-white mt-6 flex-wrap",
                                children: [
                                    (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.facebookAccount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        whileHover: {
                                            scale: 1.05
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.facebookAccount.startsWith("http")) ? socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.facebookAccount : "//" + (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.facebookAccount),
                                            rel: "noreferrer",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaFacebook */.Am9, {
                                                className: "h-8 w-8 my-1 mr-2 cursor-pointer",
                                                fill: StaticColours.v2.blue,
                                                stroke: StaticColours.v2.blue
                                            })
                                        })
                                    }),
                                    (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.twitterAccount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        whileHover: {
                                            scale: 1.05
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.twitterAccount.startsWith("http")) ? socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.twitterAccount : "//" + (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.twitterAccount),
                                            rel: "noreferrer",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {
                                                className: "h-8 w-8 my-1 mr-2 cursor-pointer",
                                                fill: StaticColours.v2.blue,
                                                stroke: StaticColours.v2.blue
                                            })
                                        })
                                    }),
                                    (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.instagramAccount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        whileHover: {
                                            scale: 1.05
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.instagramAccount.startsWith("http")) ? socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.instagramAccount : "//" + (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.instagramAccount),
                                            rel: "noreferrer",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
                                                className: "h-8 w-8 my-1 mr-2 cursor-pointer",
                                                fill: StaticColours.v2.blue,
                                                stroke: StaticColours.v2.blue
                                            })
                                        })
                                    }),
                                    (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.linkedinAccount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        whileHover: {
                                            scale: 1.05
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.linkedinAccount.startsWith("http")) ? socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.linkedinAccount : "//" + (socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.linkedinAccount),
                                            rel: "noreferrer",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaLinkedin */.ltd, {
                                                className: "h-8 w-8 my-1 mr-2 cursor-pointer",
                                                fill: StaticColours.v2.blue,
                                                stroke: StaticColours.v2.blue
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                show: !!(speaker === null || speaker === void 0 ? void 0 : speaker.bio),
                className: "flex mt-4 w-full space-x-2 text-white",
                children: speaker === null || speaker === void 0 ? void 0 : speaker.bio
            })
        ]
    });
};
/* harmony default export */ var event_SpeakerModal = (SpeakerModal);

// EXTERNAL MODULE: ./libs/useStatistics.ts
var useStatistics = __webpack_require__(23638);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(29039);
// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
// EXTERNAL MODULE: ./libs/Utility/parsers.tsx
var parsers = __webpack_require__(40654);
// EXTERNAL MODULE: ./libs/Utility/register.util.ts
var register_util = __webpack_require__(49981);
;// CONCATENATED MODULE: ./graphql/events/updateEvent.ts

const UPDATE_EVENT = (0,_generated/* graphql */.B)("\n  mutation UpdateEvent($input: UpdateEventInput!) {\n    updateEvent(input: $input) {\n      eventId\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/GoogleAdsManager.tsx
var GoogleAdsManager = __webpack_require__(25875);
// EXTERNAL MODULE: ./libs/Payments/usePaymentStatusPolling.ts
var usePaymentStatusPolling = __webpack_require__(79258);
// EXTERNAL MODULE: ./components/base/GoogleTags.tsx
var GoogleTags = __webpack_require__(507);
;// CONCATENATED MODULE: ./pages/event/[eventId]/index.tsx































// import Card from '@components/event/Card'
// import { isValidUrl, fixUrlProtocol } from '@libs/Utility/parsers'



// import Tooltip from '@components/tootilp/Tooltip'













const ERROR_ROUTE = "/";
var __N_SSP = true;
const eventIdsMap = {
    "uofglasgow-global-burns": "e4af5751-be4f-4a28-a17c-4e6fe64adf25",
    "flow-breakfast-fundraiser": "86ebb3f9-d291-4ab9-abad-535c6bcfc2a2",
    "forumm-academy-webinar": "86f62339-45b3-497f-91d0-cdf70567ccf3",
    "forumm-academy-alumni-engagement-round-table": "dbdacdf2-030f-4682-9788-9ece2f721359",
    "sussex-1980s-reunion": "59080128-59d6-4164-a824-0e48b01ef75f",
    "sussex-1960s-reunion": "2af2f67c-57aa-4b6a-b89e-dc46c3a1333a",
    edtechfirst: "5e35a0e5-52e7-4e47-a9c8-ae04c74c463d",
    scn: "21df52ff-ae4a-4297-b9ef-6055f7da6b0b",
    tectonic: "31fffe01-557f-4c3c-a7f3-cb1ec9772277",
    sps2026: "7f75a75d-ab8a-4b14-8acd-1b789f5bcdfa",
    infiniteintention: "c2cba07a-a403-440c-8f0e-6f0788ad907b",
    golfbusinessclubfeb: "3e2c2b29-5f98-4be7-8740-2b466a8b022c",
    howlingatthemoon: "4676358b-ee5e-4f4c-812c-3cca9ff61bcf",
    wintersunshineball: "368417aa-3a45-47a8-a009-5a7f1c00223d",
    tectonicnightsummit26: "e9b5be85-1f71-409b-8b4b-67d3700853f6"
};
const getSocialIcon = (platform)=>{
    if (platform.toLowerCase() === "facebook") return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaFacebook */.Am9, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "twitter") return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "instagram") return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "linkedin") return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaLinkedin */.ltd, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaFacebook */.Am9, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
};
function EventPage(param) {
    let { metadata  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    const router = (0,next_router.useRouter)();
    const paymentQuery = Array.isArray(router.query.payment) ? router.query.payment[0] : router.query.payment;
    const paymentOrderId = Array.isArray(router.query.orderId) ? router.query.orderId[0] : router.query.orderId;
    const { state: paymentState  } = (0,usePaymentStatusPolling/* usePaymentStatusPolling */.B)(paymentOrderId, paymentQuery === "processing");
    const [updateEvent] = (0,useMutation/* useMutation */.D)(UPDATE_EVENT);
    const _statisticId = (0,useStatistics/* default */.Z)();
    const { profile , isLogged , isOrganizer , isAdmin , canEditEvent , getPermission  } = (0,useAuth/* useAuth */.aC)();
    const { data: me  } = (0,useQuery/* useQuery */.a)(ME);
    const membershipAccess = getPermission("USER::MEMBERSHIP::*");
    const { setTheme , theme , StaticColours , refreshTheme  } = (0,useTheme/* useTheme */.Fg)();
    const [addUserData] = (0,useMutation/* useMutation */.D)(ADD_USER_DATA);
    const [showFieldModal, setShowFieldModal] = (0,react.useState)(false);
    const [eventHasTicketsAvailable, setEventHasTicketsAvailable] = (0,react.useState)(true);
    const [requiredInfo, setRequiredInfo] = (0,react.useState)([]);
    const [eventAttendees, setEventAttendees] = (0,react.useState)([]);
    const [fieldVals, setFieldVals] = (0,react.useState)();
    const [speakerModalTarget, setSpeakerModalTarget] = (0,react.useState)(undefined);
    const [shareButtonText, setShareButtonText] = (0,react.useState)("Share");
    const dynamicStyle = (0,util/* getDynamicStyle */.nT)(theme.highlightColour);
    const [event, setEvent] = (0,react.useState)(undefined);
    const [userRegistrationFields, setUserRegistrationFields] = (0,react.useState)([]);
    const [registrationError, setRegistrationError] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        if (paymentQuery !== "processing") return;
        if (paymentState === "processing") {
            dist/* toast.loading */.Am.loading("Confirming your bank payment...", {
                id: "payment-status"
            });
            return;
        }
        if (paymentState === "confirmed") {
            dist/* toast.success */.Am.success("Payment confirmed. Your tickets are ready!", {
                id: "payment-status",
                duration: 10000
            });
            return;
        }
        if (paymentState === "failed") {
            dist/* toast.error */.Am.error("Payment failed. Your tickets were not confirmed.", {
                id: "payment-status",
                duration: 10000
            });
            return;
        }
        if (paymentState === "timed_out") {
            (0,dist/* toast */.Am)("Payment is still processing. Check your email before trying again.", {
                id: "payment-status",
                duration: 10000
            });
        }
    }, [
        paymentQuery,
        paymentState
    ]);
    const pageUrl = "https://app.".concat("forumm.to").concat(router.asPath);
    let mediaType = "VIDEO";
    let videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background.mp4";
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "c2cba07a-a403-440c-8f0e-6f0788ad907b") videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Infinite+Intentions+Video+(1).mp4";
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "c987cfd9-3732-4d21-a586-293ed6d36784") videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background_CE.mp4";
    // Sussex BSMS Hardship Grants
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "cd54965b-4538-44bf-b177-1f0837706cee") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Sussex+Banner+Option.png";
        mediaType = "IMG";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "e172670e-a062-4f05-9e33-b334a57fff93") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Forumm+Header.jpg";
        mediaType = "IMG";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "236e01cf-bcfb-41e0-94e9-4c173e2e16f4") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/pawel-czerwinski-W_mfoOi1Elc-unsplash.jpg";
        mediaType = "IMG";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "acc6d01b-d339-4dfc-9df3-8ccef3ec7594") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/The+Scottish+Marketing+Network+Highlight+Reel.mp4";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "deef2f23-a324-42bb-8cac-e632e135faee" || (event === null || event === void 0 ? void 0 : event.eventId) === "795fdc4b-10fa-4f16-8be6-7046e1b3a6bc") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Hampden+Park+Banner.jpg";
        mediaType = "IMG";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "91947a10-235c-4e1e-94bd-442257efec8d") {
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Celtic+Park+Background.png";
        mediaType = "IMG";
    }
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "e9b5be85-1f71-409b-8b4b-67d3700853f6") videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Forumm+Highlight+Video-1.m4v";
    if ((event === null || event === void 0 ? void 0 : event.eventId) === "1fce6cb9-b5c3-45f5-ab48-f453a22215a3") videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Anmara.mp4";
    const [getEventForUnregisteredUser] = (0,useLazyQuery/* useLazyQuery */.t)(GetEventByIdForUnregisteredUser/* GET_EVENT_BY_ID_FOR_UNREGISTERED_USER */.A);
    const userData = router.query.ud;
    const [ctaLabel, setCtaLabel] = (0,react.useState)();
    const getCtaLabel = ()=>{
        var ref, ref1, ref2, ref3, ref4;
        const currentDate = new Date(Date.now()).valueOf();
        const endDate = moment_default()(event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.endDateTime).toDate().valueOf();
        const entryTime = moment_default()(event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.entryDateTime).toDate().valueOf();
        const endDatePlus15Minutes = new Date(endDate + 15 * 60 * 1000).valueOf();
        var ref5;
        const hasMembership = membershipAccess.includes((ref5 = event === null || event === void 0 ? void 0 : (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName) !== null && ref5 !== void 0 ? ref5 : "*");
        let hasTicket = getTicketStatus();
        let label = hasTicket ? "Enter Event Hub" : "Register for Event";
        let enabled = true;
        let show = true;
        let icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegCalendarCheck */.smD, {
            style: {
                fill: "#fff",
                marginLeft: "5px"
            },
            fontSize: "1em"
        });
        const canViewEarly = (()=>{
            var ref, ref1;
            const eventOrgName = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName;
            if (isAdmin) return true;
            if (isOrganizer) {
                if (eventOrgName === (profile === null || profile === void 0 ? void 0 : profile.university)) return true;
                if (eventOrgName === (profile === null || profile === void 0 ? void 0 : profile.company)) return true;
            }
            if (event === null || event === void 0 ? void 0 : (ref1 = event.speakers) === null || ref1 === void 0 ? void 0 : ref1.find((s)=>{
                var ref, ref1;
                return ((ref = s.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (profile === null || profile === void 0 ? void 0 : (ref1 = profile.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
            })) return true;
            return false;
        })();
        var ref6;
        const requiredFieldNames = (ref6 = event === null || event === void 0 ? void 0 : (ref3 = event.registrationFields) === null || ref3 === void 0 ? void 0 : ref3.map((f)=>f.name)) !== null && ref6 !== void 0 ? ref6 : [];
        //Participants with tickets should not be able to join the event until it has started
        if (hasTicket && currentDate < entryTime && !canViewEarly) {
            enabled = false;
        }
        let action = ()=>{
            if (hasTicket && me) {
                var ref;
                var _registrationFields;
                const myFields = (_registrationFields = me.me.registrationFields) !== null && _registrationFields !== void 0 ? _registrationFields : {};
                const myFieldNames = [];
                Object.keys(myFields).forEach((key)=>{
                    Object.keys(myFields[key]).forEach((k)=>{
                        myFieldNames.push(k);
                    });
                });
                const attendeeData = event === null || event === void 0 ? void 0 : (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.find((a)=>{
                    return a.email === (profile === null || profile === void 0 ? void 0 : profile.email) || a.userId === (profile === null || profile === void 0 ? void 0 : profile.userId);
                });
                const missingFieldNames = lodash_default().difference(requiredFieldNames, myFieldNames);
                if (missingFieldNames.length > 0 && // !isAdmin &&
                (attendeeData === null || attendeeData === void 0 ? void 0 : attendeeData.requireRegistrationFields) !== false) {
                    setRequiredInfo(missingFieldNames);
                    setShowFieldModal(true);
                } else {
                    router.push("/event/".concat(event === null || event === void 0 ? void 0 : event.eventId, "/agenda"));
                }
            } else {
                if ((event === null || event === void 0 ? void 0 : event.isPremium) && !hasMembership) {
                    var ref1;
                    router.push("/membership/".concat(event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName));
                } else {
                    if (userData) router.push("/event/".concat(event === null || event === void 0 ? void 0 : event.eventId, "/register?ud=").concat(userData));
                    router.push("/event/".concat(event === null || event === void 0 ? void 0 : event.eventId, "/register"));
                }
            }
        };
        if (currentDate < entryTime && hasTicket && !canViewEarly) {
            label = "Event not started";
            enabled = false;
        } else if (currentDate > endDatePlus15Minutes) {
            label = "Event ended";
            enabled = false;
        }
        if (!hasTicket && !eventHasTicketsAvailable) {
            label = "Sold Out";
            enabled = false;
        }
        if (!hasTicket && !canRegister) {
            label = "Registration Closed";
            enabled = false;
        }
        if ((event === null || event === void 0 ? void 0 : (ref4 = event.event) === null || ref4 === void 0 ? void 0 : ref4.eventType) === graphql/* EventType.InPerson */.tw.InPerson && hasTicket) {
            label = "Registered";
            enabled = false;
        }
        if (hasTicket && currentDate > entryTime && currentDate < endDatePlus15Minutes) {
            enabled = true;
        }
        if (!hasTicket && !hasMembership && (event === null || event === void 0 ? void 0 : event.isPremium) && currentDate < endDatePlus15Minutes) {
            label = "Membership Required";
            enabled = true;
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaStar */.QJe, {
                className: "ml-2",
                fill: "white"
            });
        }
        const payload = {
            label,
            enabled,
            action,
            show,
            icon
        };
        console.log({
            CTA: payload
        });
        setCtaLabel(payload);
        return payload;
    };
    const eventId = (()=>{
        const eventIdQuery = router.query.eventId;
        if (eventIdQuery) {
            const decodedEventId = decodeURIComponent(eventIdQuery).trim().toLowerCase();
            if (eventIdsMap[eventIdQuery]) return eventIdsMap[eventIdQuery];
            if (eventIdsMap[decodedEventId]) return eventIdsMap[decodedEventId];
        }
        return eventIdQuery;
    })();
    const canGetPortal = isOrganizer || isAdmin || !!profile;
    const shouldSkipQuery = !router.query.eventId || !canGetPortal;
    const { loading , error , data , refetch , startPolling , stopPolling  } = (0,useQuery/* useQuery */.a)(GET_EVENT_PORTAL_BY_ID, {
        variables: {
            input: {
                eventId: eventId
            }
        },
        skip: shouldSkipQuery,
        fetchPolicy: "network-only",
        onCompleted: getCtaLabel
    });
    (0,react.useEffect)(()=>{
        if (shouldSkipQuery) return;
        startPolling(2000);
        const pollingTimeout = setTimeout(stopPolling, 10000);
        return ()=>{
            clearTimeout(pollingTimeout);
            stopPolling();
        };
    }, [
        eventId,
        shouldSkipQuery,
        startPolling,
        stopPolling
    ]);
    (0,react.useEffect)(()=>{
        if (event) {
            const cachedEvent = {
                ...event,
                stages: [],
                breakoutRooms: []
            };
            const latestEvent = {
                ...data === null || data === void 0 ? void 0 : data.getEventById,
                stages: [],
                breakoutRooms: []
            };
            const eventChaged = JSON.stringify(cachedEvent) !== JSON.stringify(latestEvent);
            if (!eventChaged) return;
        }
        if (!!(data === null || data === void 0 ? void 0 : data.getEventById)) {
            var ref;
            setTheme({
                ...theme,
                organisationName: (ref = data.getEventById.event) === null || ref === void 0 ? void 0 : ref.organizationName
            });
            return setEvent(data.getEventById);
        }
        if (eventId && !loading && !data && !profile) {
            getEventForUnregisteredUser({
                variables: {
                    input: {
                        eventId: eventId,
                        userEmail: encodeURIComponent(userData)
                    }
                }
            }).then((d)=>{
                var ref;
                if ((ref = d.data) === null || ref === void 0 ? void 0 : ref.getEventByIdForUnregisteredUser) {
                    var ref1, ref2;
                    setTheme({
                        ...theme,
                        organisationName: (ref1 = d.data.getEventByIdForUnregisteredUser.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName
                    });
                    setEvent((ref2 = d.data) === null || ref2 === void 0 ? void 0 : ref2.getEventByIdForUnregisteredUser);
                }
                if (d.error) {
                    console.error(d.error);
                    router.push(ERROR_ROUTE);
                }
            });
        }
    }, [
        loading,
        data,
        userData,
        eventId
    ]);
    const canRegister = moment_default()(event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.registrationCloseDateTime).isAfter(moment_default()());
    const canViewOrganizerInfo = (0,react.useMemo)(()=>{
        return isAdmin || isOrganizer && canEditEvent(event);
    }, [
        event,
        isOrganizer,
        isAdmin
    ]);
    const trackedEventDetailIdRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        const loadedEventId = event === null || event === void 0 ? void 0 : event.eventId;
        if (!router.isReady || !loadedEventId || canViewOrganizerInfo || Object.prototype.hasOwnProperty.call(router.query, "registered") || trackedEventDetailIdRef.current === loadedEventId || !(0,GoogleTags/* shouldTrackBuyTicketEventDetail */.Ed)(loadedEventId)) return;
        (0,GoogleTags/* pushDataLayerEvent */.Jt)("buy_ticket_event_detail");
        trackedEventDetailIdRef.current = loadedEventId;
    }, [
        canViewOrganizerInfo,
        event === null || event === void 0 ? void 0 : event.eventId,
        router.isReady,
        router.query.registered
    ]);
    const attendeeBox = (0,react.useMemo)(()=>{
        var ref, ref1, ref2;
        if (// !canViewOrganizerInfo &&
        !!event && !!event.attendees && !!event.registrationFields && !!((ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(event_AttendeeBox, {
            show: (event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.showAttendeeBox) || (0,register_util/* getRegistrationConfig */.rS)(register_util/* CONFIG_OPTIONS.SHOW_ATTENDEE_BOX */.ce.SHOW_ATTENDEE_BOX, event),
            eventId: eventId,
            event: {
                attendees: event.attendees,
                registrationFields: event.registrationFields,
                organisationName: (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName
            }
        });
    }, [
        isAdmin,
        isOrganizer,
        data,
        event
    ]);
    const getTicketStatus = ()=>{
        var ref, ref1, ref2, ref3;
        if (isAdmin) return true;
        if (isOrganizer && ((profile === null || profile === void 0 ? void 0 : profile.company) === (event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName) || (profile === null || profile === void 0 ? void 0 : profile.university) === (event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName))) return true;
        var ref4, ref5;
        const userHasTicket = [
            ...(ref4 = event === null || event === void 0 ? void 0 : (ref2 = event.attendees) === null || ref2 === void 0 ? void 0 : ref2.map((a)=>{
                var ref;
                return (ref = a.email) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            })) !== null && ref4 !== void 0 ? ref4 : [],
            ...(ref5 = event === null || event === void 0 ? void 0 : (ref3 = event.speakers) === null || ref3 === void 0 ? void 0 : ref3.map((s)=>{
                var ref;
                return (ref = s.email) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            })) !== null && ref5 !== void 0 ? ref5 : [],
            event === null || event === void 0 ? void 0 : event.organizerId
        ].some((id)=>{
            var ref, ref1;
            if (!id) return false;
            return id === (profile === null || profile === void 0 ? void 0 : (ref = profile.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || id === (profile === null || profile === void 0 ? void 0 : (ref1 = profile.userId) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
        });
        return userHasTicket;
    };
    (0,react.useEffect)(()=>{
        if (event && (event === null || event === void 0 ? void 0 : event.eventId)) {
            getCtaLabel();
        }
    }, [
        event,
        profile
    ]);
    const trackedRegistrationCompleteIdRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        const loadedEventId = event === null || event === void 0 ? void 0 : event.eventId;
        if (!router.isReady || !loadedEventId) return;
        if (!Object.prototype.hasOwnProperty.call(router.query, "registered")) return;
        if (trackedRegistrationCompleteIdRef.current === loadedEventId) return;
        (0,GoogleTags/* pushDataLayerEvent */.Jt)("buy_ticket_registration_complete");
        trackedRegistrationCompleteIdRef.current = loadedEventId;
        (0,GoogleTags/* clearBuyTicketEventDetail */.FT)(loadedEventId);
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete("registered");
        window.history.replaceState(window.history.state, "", "".concat(currentUrl.pathname).concat(currentUrl.search).concat(currentUrl.hash));
        (0,dist/* toast */.Am)("Successfully registered for the event!", {
            icon: "\uD83C\uDF89",
            duration: 10000
        });
    }, [
        event === null || event === void 0 ? void 0 : event.eventId,
        router.isReady,
        router.query.registered
    ]);
    (0,react.useEffect)(()=>{
        if (!event && !data && error && !loading && !shouldSkipQuery) {
            if (!isLogged && !userData) router.push(ERROR_ROUTE);
            if (isLogged && profile) router.push(ERROR_ROUTE);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error,
        data,
        profile,
        isLogged
    ]);
    (0,react.useEffect)(()=>{
        const getTicketsAvailable = ()=>{
            var ref, ref1;
            let totalAvailable = 0;
            event === null || event === void 0 ? void 0 : (ref = event.availableTickets) === null || ref === void 0 ? void 0 : (ref1 = ref.tickets) === null || ref1 === void 0 ? void 0 : ref1.forEach((t)=>{
                if (t && t.remaining && (0,lodash.parseInt)(t.remaining) > 0) totalAvailable += (0,lodash.parseInt)(t.remaining);
            });
            return totalAvailable > 0;
        };
        if (event) {
            refreshTheme(event);
            setEventHasTicketsAvailable(getTicketsAvailable());
        }
    }, [
        event,
        refreshTheme
    ]);
    (0,react.useEffect)(()=>{
        if (event) {
            setEventAttendees((event === null || event === void 0 ? void 0 : event.attendees) || []);
        }
    }, [
        event
    ]);
    if (loading || !event) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "w-full py-64 flex justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                        size: "large"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                        toastOptions: {
                            className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                            duration: 4000
                        }
                    })
                ]
            })
        });
    }
    const isDarkTheme = theme.type === "DARK";
    const buttonDonate = isDarkTheme ? "bg-forumm-light-blue-dark text-forumm-text-blue-dark" : "bg-forumm-active-blue text-white";
    var ref39;
    const eventImage = (ref39 = event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.bannerImage) !== null && ref39 !== void 0 ? ref39 : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png";
    const addFieldModal = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: showFieldModal,
        setShow: setShowFieldModal,
        title: "Add Required information",
        children: [
            event === null || event === void 0 ? void 0 : (ref2 = event.registrationFields) === null || ref2 === void 0 ? void 0 : ref2.map((field)=>{
                const id = "".concat(profile === null || profile === void 0 ? void 0 : profile.userId, "-").concat(eventId);
                const fieldName = "".concat(profile === null || profile === void 0 ? void 0 : profile.userId, "::").concat(field.name.replaceAll(" ", "_").toLowerCase());
                var _required, ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPicker/* InputPicker */.X, {
                        ukey: "registration_field_input_".concat(id),
                        type: !!field.type ? field.type : graphql/* FormInputType.Text */.Tx.Text,
                        dateOnly: !!(field === null || field === void 0 ? void 0 : field.dateOnly) ? field.dateOnly : false,
                        validations: {
                            minLength: {
                                value: 1,
                                message: "Field name must be at least 1 character"
                            }
                        },
                        value: fieldVals ? fieldVals[field.name] : undefined,
                        onChange: (e)=>{
                            let payload = {
                                ...fieldVals
                            };
                            payload = {
                                ...payload,
                                [field.name]: e
                            };
                            let errorPayload = registrationError;
                            if (errorPayload === null || errorPayload === void 0 ? void 0 : errorPayload[fieldName]) errorPayload[fieldName] = undefined;
                            setRegistrationError(errorPayload);
                            setFieldVals(payload);
                        },
                        required: (_required = field.required) !== null && _required !== void 0 ? _required : false,
                        label: field.name,
                        placeholder: field.name,
                        options: (ref = field === null || field === void 0 ? void 0 : field.options) !== null && ref !== void 0 ? ref : [],
                        error: registrationError === null || registrationError === void 0 ? void 0 : registrationError[fieldName]
                    })
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: "my-4",
                title: "Submit",
                type: "primary",
                buttonType: "submit",
                onClick: async ()=>{
                    const values = Object.keys(fieldVals).map((key)=>({
                            name: key,
                            value: fieldVals[key]
                        }));
                    console.log({
                        values
                    });
                    if (values.length > 0 && values.filter((v)=>v.value === "").length === 0) {
                        var ref;
                        var ref1;
                        await addUserData({
                            variables: {
                                input: {
                                    company: (ref1 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName) !== null && ref1 !== void 0 ? ref1 : "Unknown",
                                    values: values
                                }
                            }
                        })// Used to set requiredRegistration to false after the user completes the registration answers
                        // .then(async () => {
                        //   const attendees = (cleanGqlPayload(event.attendees) ??
                        //     []) as EventAttendeeInput[]
                        //   const payload: EventAttendeeInput = {
                        //     ...(attendees?.find((a) => a.email === profile?.email) ?? []),
                        //     requireRegistrationFields: false,
                        //   } as EventAttendeeInput
                        //
                        //   if (
                        //     !!event &&
                        //     !!event.attendees &&
                        //     payload.email === profile?.email
                        //   )
                        //     await updateEvent({
                        //       variables: {
                        //         input: {
                        //           eventId: eventId as string,
                        //           attendees: [...attendees, payload],
                        //         },
                        //       },
                        //     })
                        // })
                        .finally(()=>{
                            return router.push("/event/".concat(event === null || event === void 0 ? void 0 : event.eventId, "/agenda"));
                        });
                    }
                }
            })
        ]
    });
    const getSocialLink = (platform, fallbackURL)=>{
        var ref, ref1, ref2;
        var ref3, ref4;
        return (ref4 = (ref3 = (ref2 = event === null || event === void 0 ? void 0 : (ref = event.communications) === null || ref === void 0 ? void 0 : (ref1 = ref.socials) === null || ref1 === void 0 ? void 0 : ref1.find((s)=>s.platform.toLowerCase() === platform.toLowerCase())) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref3 !== void 0 ? ref3 : fallbackURL) !== null && ref4 !== void 0 ? ref4 : false;
    };
    const noAnnouncements = !(event === null || event === void 0 ? void 0 : (ref3 = event.communications) === null || ref3 === void 0 ? void 0 : ref3.announcements);
    const announcements = noAnnouncements ? [] : event === null || event === void 0 ? void 0 : (ref4 = event.communications) === null || ref4 === void 0 ? void 0 : ref4.announcements;
    const publiclyVisibleAttendes = (eventAttendees !== null && eventAttendees !== void 0 ? eventAttendees : []).filter((at)=>at.registrationVisible);
    const visibleAttendees = canViewOrganizerInfo ? eventAttendees : publiclyVisibleAttendes;
    const sessionReplay = (0,util/* getSessionReplay */.gu)(event);
    var ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48;
    // console.log({
    //   sessionReplay,
    //   id: sessionReplay && parseHoldingVideoURL(sessionReplay),
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "-mt-[80px] pt-[80px] overflow-x-hidden h-[calc(100vh)] relative",
            children: [
                addFieldModal,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(event_SpeakerModal, {
                    show: !!speakerModalTarget,
                    setShow: setSpeakerModalTarget,
                    speaker: speakerModalTarget
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    color: "foregroundColour",
                    style: dynamicStyle,
                    className: "relative px-2 pt-9 pb-9 border-b border-forumm-menu-border",
                    children: [
                        mediaType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            playsInline: true,
                            className: "absolute inset-0 w-full h-full object-cover select-none no-controls",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: videoUrl,
                                type: "video/mp4"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: videoUrl,
                            alt: "Background Image",
                            className: "absolute inset-0 w-full h-full object-cover select-none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                                color: "backgroundColorBanner",
                                style: {
                                    background: isDarkTheme ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)",
                                    backdropFilter: "blur(5px)",
                                    WebkitBackdropFilter: "blur(5px)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "flex flex-col items-center md:flex-row md:items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex ml-0 md:ml-3 items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2 mb-2 md:mb-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "h-full w-full bg-cover bg-center",
                                                    style: {
                                                        backgroundImage: "url('".concat(eventImage, "')")
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "flex flex-row items-center mb-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                alt: "Thumbnail Image",
                                                                className: "h-10 w-10 rounded-full mr-3 object-cover",
                                                                width: 30,
                                                                height: 30,
                                                                src: (ref40 = event === null || event === void 0 ? void 0 : (ref5 = event.event) === null || ref5 === void 0 ? void 0 : ref5.thumbnailImage) !== null && ref40 !== void 0 ? ref40 : default_thumbnail/* default */.Z
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "flex items-center text-xs md:text-sm !text-gray-600 cursor-pointer",
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    router.push("/org/".concat((ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName.toLowerCase().replaceAll(" ", "-")));
                                                                },
                                                                children: event === null || event === void 0 ? void 0 : (ref6 = event.event) === null || ref6 === void 0 ? void 0 : ref6.organizationName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-[36px] w-full font-bold",
                                                        children: event === null || event === void 0 ? void 0 : (ref7 = event.event) === null || ref7 === void 0 ? void 0 : ref7.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mb-4",
                                                        style: {
                                                            whiteSpace: "pre-wrap"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                                            className: "text-xs md:text-sm mt- mb-4 !text-gray-600",
                                                            children: event === null || event === void 0 ? void 0 : (ref8 = event.event) === null || ref8 === void 0 ? void 0 : ref8.shortDescription
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        show: !!((ref9 = event.event) === null || ref9 === void 0 ? void 0 : ref9.eventLocation) || !!(event === null || event === void 0 ? void 0 : (ref10 = event.event) === null || ref10 === void 0 ? void 0 : ref10.internalLocation),
                                                        className: "",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "text-md font-bold",
                                                                children: "Event Location"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextLink/* default */.Z, {
                                                                className: "text-xs md:text-sm !text-gray-600",
                                                                children: [
                                                                    (event === null || event === void 0 ? void 0 : (ref11 = event.event) === null || ref11 === void 0 ? void 0 : ref11.isInternal) ? (event === null || event === void 0 ? void 0 : (ref12 = event.event) === null || ref12 === void 0 ? void 0 : ref12.internalLocation) || (event === null || event === void 0 ? void 0 : (ref13 = event.event) === null || ref13 === void 0 ? void 0 : ref13.eventLocation) : event === null || event === void 0 ? void 0 : (ref14 = event.event) === null || ref14 === void 0 ? void 0 : ref14.eventLocation,
                                                                    " "
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        show: !!(event === null || event === void 0 ? void 0 : (ref15 = event.event) === null || ref15 === void 0 ? void 0 : ref15.eventLocationMapLink) && !!((event === null || event === void 0 ? void 0 : (ref16 = event.event) === null || ref16 === void 0 ? void 0 : ref16.eventLocationMapLink.length) > 0),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: (ref41 = event === null || event === void 0 ? void 0 : (ref17 = event.event) === null || ref17 === void 0 ? void 0 : ref17.eventLocationMapUrl) !== null && ref41 !== void 0 ? ref41 : "#",
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "text-xs md:text-sm text-forumm-blue underline",
                                                            children: event === null || event === void 0 ? void 0 : (ref18 = event.event) === null || ref18 === void 0 ? void 0 : ref18.eventLocationMapLink
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "flex mb-4 mt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                className: "flex flex-col space-y-2 mr-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "text-md font-bold !-mb-1",
                                                                        children: "Start Time/Date"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "text-xs md:text-sm !text-gray-600",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDateTime/* default */.Z, {
                                                                            value: event === null || event === void 0 ? void 0 : (ref19 = event.event) === null || ref19 === void 0 ? void 0 : ref19.startDateTime,
                                                                            format: "MMM DD, h:mmA",
                                                                            event: event === null || event === void 0 ? void 0 : event.event
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                className: "flex flex-col space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "text-md font-bold !-mb-1",
                                                                        children: "End Time/Date"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "text-xs md:text-sm !text-gray-600",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDateTime/* default */.Z, {
                                                                            value: event === null || event === void 0 ? void 0 : (ref20 = event.event) === null || ref20 === void 0 ? void 0 : ref20.endDateTime,
                                                                            format: "MMM DD, h:mmA",
                                                                            event: event === null || event === void 0 ? void 0 : event.event
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        show: !!(event === null || event === void 0 ? void 0 : (ref21 = event.communications) === null || ref21 === void 0 ? void 0 : ref21.socials) && (event === null || event === void 0 ? void 0 : (ref22 = event.communications) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.socials) === null || ref23 === void 0 ? void 0 : ref23.length) > 0,
                                                        className: "flex items-center justify-start text-white mt-6 flex-wrap mb-4",
                                                        children: event === null || event === void 0 ? void 0 : (ref24 = event.communications) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.socials) === null || ref25 === void 0 ? void 0 : ref25.map((s)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                                whileHover: {
                                                                    scale: 1
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: s.url,
                                                                    target: "_blank",
                                                                    "data-testid": "social-facebook",
                                                                    children: getSocialIcon(s.platform)
                                                                })
                                                            }, s.platform);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "flex items-center sm:mt-0 flex-wrap justify-between lg:justify-start",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                show: ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.show,
                                                                title: "".concat((ref42 = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.label) !== null && ref42 !== void 0 ? ref42 : "Register to Event"),
                                                                disabled: !(ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.enabled),
                                                                onClick: ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.action,
                                                                icon: (ref43 = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.icon) !== null && ref43 !== void 0 ? ref43 : /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegCalendarCheck */.smD, {
                                                                    style: {
                                                                        fill: "#fff",
                                                                        marginLeft: "5px"
                                                                    },
                                                                    fontSize: "1em"
                                                                }),
                                                                className: "mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ".concat(buttonDonate)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                show: (!!((ref26 = event.fundraising) === null || ref26 === void 0 ? void 0 : ref26.title) && event.fundraising.title.length > 0 || !!((ref27 = event.event) === null || ref27 === void 0 ? void 0 : ref27.donationUrl)) && !!(event === null || event === void 0 ? void 0 : (ref28 = event.fundraising) === null || ref28 === void 0 ? void 0 : ref28.enabled),
                                                                className: "mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ".concat(buttonDonate),
                                                                title: "Donate",
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaDonate */.s0p, {
                                                                    style: {
                                                                        fill: "#fff",
                                                                        marginLeft: "5px"
                                                                    },
                                                                    fontSize: "1em"
                                                                }),
                                                                onClick: ()=>router.push("/event/".concat(event.eventId, "/donate"))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                className: "mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ".concat(buttonDonate),
                                                                title: shareButtonText,
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "13",
                                                                    height: "16",
                                                                    viewBox: "0 0 13 16",
                                                                    fill: "#fff",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "mr-1",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M11.375 0.601562H4.625C3.8 0.601562 3.125 1.27656 3.125 2.10156V11.1016C3.125 11.9266 3.8 12.6016 4.625 12.6016H11.375C12.2 12.6016 12.875 11.9266 12.875 11.1016V2.10156C12.875 1.27656 12.2 0.601562 11.375 0.601562ZM11.375 11.1016H4.625V2.10156H11.375V11.1016ZM0.125 10.3516V8.85156H1.625V10.3516H0.125ZM0.125 6.22656H1.625V7.72656H0.125V6.22656ZM5.375 14.1016H6.875V15.6016H5.375V14.1016ZM0.125 12.9766V11.4766H1.625V12.9766H0.125ZM1.625 15.6016C0.8 15.6016 0.125 14.9266 0.125 14.1016H1.625V15.6016ZM4.25 15.6016H2.75V14.1016H4.25V15.6016ZM8 15.6016V14.1016H9.5C9.5 14.9266 8.825 15.6016 8 15.6016ZM1.625 3.60156V5.10156H0.125C0.125 4.27656 0.8 3.60156 1.625 3.60156Z"
                                                                    })
                                                                }),
                                                                onClick: (e)=>{
                                                                    navigator.clipboard.writeText("https://".concat(window.location.hostname).concat(router.asPath));
                                                                    setShareButtonText("Copied!");
                                                                    setTimeout(()=>{
                                                                        setShareButtonText("Share");
                                                                    }, 3000);
                                                                    e.preventDefault();
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                show: isOrganizer && canEditEvent(event),
                                                                className: "mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ".concat(buttonDonate),
                                                                title: "Edit",
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdEdit */.zmo, {
                                                                    style: {
                                                                        fill: "#fff"
                                                                    },
                                                                    fontSize: "1.5em"
                                                                }),
                                                                onClick: ()=>{
                                                                    router.push("/create-event?id=".concat(event.eventId));
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    !loading && !profile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "mt-4 text-xs md:text-sm",
                                                        children: [
                                                            "Already registered?",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                className: "underline",
                                                                href: {
                                                                    pathname: "/login",
                                                                    query: {
                                                                        intent: "buy_ticket",
                                                                        redirect: router.asPath
                                                                    }
                                                                },
                                                                children: "Log in here"
                                                            }),
                                                            ". Having trouble? Email",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "underline",
                                                                href: "mailto:hello@forumm.to",
                                                                children: "hello@forumm.to"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "sm:px-4 w-full flex justify-center ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "w-full md:w-[85%] max-w-[1500px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "mt-8 mb-64",
                            children: [
                                announcements && announcements.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "p-10 rounded-xl border border-forumm-menu-border",
                                    color: "foregroundColour",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-2xl font-medium flex space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementIcon, {
                                                    fill: theme.textColour,
                                                    className: "w-8 h-8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Announcements"
                                                })
                                            ]
                                        }),
                                        !noAnnouncements ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-8",
                                            children: announcements === null || announcements === void 0 ? void 0 : announcements.map((a)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-lg mt-6 font-semibold",
                                                            children: a.title
                                                        }),
                                                        (0,util/* isJSON */.pM)(a.body) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                                                            descriptionJson: a.body
                                                        }, a.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xs md:text-sm",
                                                            children: a.body
                                                        })
                                                    ]
                                                }, a.title);
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-8 text-xs md:text-sm",
                                            children: "No Announcements"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-8 p-10 rounded-xl border border-forumm-menu-border h-full",
                                    color: "foregroundColour",
                                    show: !!sessionReplay,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-2xl font-medium flex space-x-2 mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOndemandVideo */.OeP, {
                                                    fill: theme.textColour,
                                                    className: "w-8 h-8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Session Playback"
                                                })
                                            ]
                                        }),
                                        sessionReplay.toString().includes("manual-upload") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                            // className="h-96 w-full -mt-2 -mb-4"
                                            className: "mt-6 rounded w-full h-full",
                                            controls: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                src: sessionReplay,
                                                type: "video/mp4"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                                                videoId: (0,parsers/* parseHoldingVideoURL */.HL)(sessionReplay),
                                                /* iframeClassName="pointer-events-none " */ className: "h-[70vh] mx-auto",
                                                opts: {
                                                    height: "100%",
                                                    width: "100%",
                                                    playerVars: {
                                                        version: 3,
                                                        loop: 0,
                                                        // playlist: sessionReplay,
                                                        autoplay: 0,
                                                        mute: 0,
                                                        modestbranding: 1,
                                                        showinfo: 0,
                                                        controls: 1,
                                                        enablejsapi: 1,
                                                        rel: 0
                                                    }
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            color: "foregroundColour",
                                            className: "rounded-2xl flex flex-col p-10 border border-forumm-menu-border flex-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "text-2xl font-medium",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "my-6",
                                                    style: {
                                                        whiteSpace: "pre-wrap"
                                                    },
                                                    children: [
                                                        (window.location.href.includes("forumm-academy-webinar") || window.location.href.includes("61c0465c-9177-4ac0-8d4e-7347b58d2ad8")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                                    src: "https://www.loom.com/embed/a57f9c5c676941ae950c37707242721e",
                                                                    frameBorder: "0",
                                                                    allowFullScreen: true,
                                                                    style: {
                                                                        width: "100%",
                                                                        height: "350px",
                                                                        border: "none"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "h-[25px]"
                                                                })
                                                            ]
                                                        }),
                                                        (event === null || event === void 0 ? void 0 : (ref29 = event.event) === null || ref29 === void 0 ? void 0 : ref29.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                                                            descriptionJson: event.event.description
                                                        }) : "No description provided."
                                                    ]
                                                })
                                            ]
                                        }),
                                        attendeeBox
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAdsManager/* GoogleAds */.M, {
                                    show: (0,register_util/* getOrganisationConfig */.RC)(register_util/* CONFIG_OPTIONS.SHOW_GOOGLE_ADS */.ce.SHOW_GOOGLE_ADS, (ref45 = (ref44 = (ref30 = event.event) === null || ref30 === void 0 ? void 0 : ref30.organizationName) !== null && ref44 !== void 0 ? ref44 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref45 !== void 0 ? ref45 : profile === null || profile === void 0 ? void 0 : profile.university),
                                    type: "horizontal",
                                    className: "mt-8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        show: !!(event === null || event === void 0 ? void 0 : event.sessions) && (event === null || event === void 0 ? void 0 : (ref31 = event.sessions) === null || ref31 === void 0 ? void 0 : ref31.length) > 0,
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-justify text-sm",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionList/* SessionList */.p, {
                                                sessions: (ref46 = event === null || event === void 0 ? void 0 : event.sessions) !== null && ref46 !== void 0 ? ref46 : [],
                                                eventId: event === null || event === void 0 ? void 0 : event.eventId,
                                                eventType: event === null || event === void 0 ? void 0 : (ref32 = event.event) === null || ref32 === void 0 ? void 0 : ref32.eventType,
                                                timeZone: event === null || event === void 0 ? void 0 : (ref33 = event.event) === null || ref33 === void 0 ? void 0 : ref33.timeZone,
                                                timeZoneId: event === null || event === void 0 ? void 0 : (ref34 = event.event) === null || ref34 === void 0 ? void 0 : ref34.timeZoneId
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mt-2 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full mt-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        show: !!(event === null || event === void 0 ? void 0 : event.speakers) && (event === null || event === void 0 ? void 0 : (ref35 = event.speakers) === null || ref35 === void 0 ? void 0 : ref35.length) > 0,
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-2xl font-medium",
                                                children: "Speakers"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-justify text-sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex flex-wrap mt-4 -mb-4 -mx-4 justify-center",
                                                    children: event === null || event === void 0 ? void 0 : (ref36 = event.speakers) === null || ref36 === void 0 ? void 0 : ref36.map((s, index)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "p-4 flex-1 max-w-xs text-center cursor-pointer hover:animate-heartbeat min-w-[15rem]",
                                                            onClick: ()=>setSpeakerModalTarget(s),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                className: "p-8 flex flex-col items-center rounded-lg border border-forumm-menu-border",
                                                                color: "backgroundColourSecondary",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                                                                        size: "lg",
                                                                        imageUrl: s === null || s === void 0 ? void 0 : s.profileImage
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "mt-8 font-bold text-lg",
                                                                        style: {
                                                                            minHeight: "60px"
                                                                        },
                                                                        children: s.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "mt-2",
                                                                        style: {
                                                                            minHeight: "40px"
                                                                        },
                                                                        children: s.position
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "mt-2",
                                                                        style: {
                                                                            minHeight: "40px"
                                                                        },
                                                                        children: s.organization
                                                                    })
                                                                ]
                                                            })
                                                        }, "".concat(s.email, "-").concat(index));
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    show: !!(event === null || event === void 0 ? void 0 : event.sponsors) && (event === null || event === void 0 ? void 0 : (ref37 = event.sponsors) === null || ref37 === void 0 ? void 0 : ref37.length) > 0,
                                    className: "mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-2 max-w-[100%] overflow-y-scroll scrollbar-hide",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-2xl font-medium",
                                                children: "Partners"
                                            }),
                                            (event === null || event === void 0 ? void 0 : event.sponsors) && (event === null || event === void 0 ? void 0 : event.sponsors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-xl",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex space-x-2 justify-evenly pb-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                                                        className: "inline-block w-full justify-center items-center",
                                                        items: event.sponsors.map((s)=>{
                                                            var _logoUrl, _title, _description;
                                                            return {
                                                                url: (_logoUrl = s.logoUrl) !== null && _logoUrl !== void 0 ? _logoUrl : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png",
                                                                title: (_title = s.title) !== null && _title !== void 0 ? _title : "",
                                                                description: (_description = s.description) !== null && _description !== void 0 ? _description : "",
                                                                onClick: ()=>{
                                                                    if (s.websiteUrl) {
                                                                        window.open(s.websiteUrl, "_blank");
                                                                    }
                                                                }
                                                            };
                                                        }),
                                                        fixedHeight: true
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                canViewOrganizerInfo && eventAttendees && eventAttendees.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col p-2 md:p-8 border border-forumm-menu-border flex-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-2xl font-medium",
                                                children: "Attendees"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "mt-8 text-justify text-sm",
                                                children: event && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttendeeList, {
                                                    event: event,
                                                    eventId: event.eventId,
                                                    refetchEvent: refetch,
                                                    totalIncludingHidden: eventAttendees.length,
                                                    hiddenAttendees: eventAttendees.length - publiclyVisibleAttendes.length
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAdsManager/* GoogleAds */.M, {
                                    show: (0,register_util/* getOrganisationConfig */.RC)(register_util/* CONFIG_OPTIONS.SHOW_GOOGLE_ADS */.ce.SHOW_GOOGLE_ADS, (ref48 = (ref47 = (ref38 = event.event) === null || ref38 === void 0 ? void 0 : ref38.organizationName) !== null && ref47 !== void 0 ? ref47 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref48 !== void 0 ? ref48 : profile === null || profile === void 0 ? void 0 : profile.university),
                                    type: "horizontal",
                                    className: "mt-8"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                    toastOptions: {
                        className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                        duration: 4000
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                    transparent: false
                })
            ]
        })
    });
}
EventPage.Layout = Wrapper/* UnauthenticatedWrapperNoDefaults */.SR;


/***/ })

}]);